{
  "schemaVersion": 1,
  "title": "Fontlab linked pack catalog",
  "createdAt": "2026-09-30T23:03:10.509Z",
  "status": "draft-local-only",
  "sourceCatalog": "D:/projects/l3v/georgian-type-studio/dist/catalog.json",
  "description": "A relationship catalog referencing existing fonts. No archives or font copies are created. Pack definitions are proposals, not official author releases.",
  "counts": {
    "packs": 103,
    "fonts": 289,
    "reviewGroups": 17
  },
  "packs": [
    {
      "id": "pack:001-unicode-starter-collection",
      "type": "pack",
      "name": "Unicode starter collection",
      "kind": "collection",
      "description": "Six Unicode fonts to start exploring Georgian typography.",
      "fontCount": 6,
      "status": "draft",
      "groupingBasis": [
        "editorial-selection"
      ],
      "fontIds": [
        "727",
        "696",
        "703",
        "704",
        "905",
        "906"
      ]
    },
    {
      "id": "pack:002-georgian-headline-collection",
      "type": "pack",
      "name": "Georgian headline collection",
      "kind": "collection",
      "description": "Unicode display and headline options.",
      "fontCount": 6,
      "status": "draft",
      "groupingBasis": [
        "editorial-selection"
      ],
      "fontIds": [
        "705",
        "707",
        "708",
        "712",
        "715",
        "719"
      ]
    },
    {
      "id": "pack:003-ar-archy-weight-collection",
      "type": "pack",
      "name": "AR Archy weight collection",
      "kind": "collection",
      "description": "Four weights, from Thin to SemiBold.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "editorial-selection"
      ],
      "fontIds": [
        "700",
        "696",
        "701",
        "702"
      ]
    },
    {
      "id": "pack:004-bpg-banner-collection",
      "type": "pack",
      "name": "BPG Banner collection",
      "kind": "collection",
      "description": "Related Unicode banner and caps designs.",
      "fontCount": 9,
      "status": "draft",
      "groupingBasis": [
        "editorial-selection"
      ],
      "fontIds": [
        "712",
        "713",
        "714",
        "715",
        "716",
        "717",
        "718",
        "719",
        "720"
      ]
    },
    {
      "id": "pack:005-aaacademiury-std8-geo-sp",
      "type": "pack",
      "name": "AAAcademiury - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "56",
        "57"
      ]
    },
    {
      "id": "pack:006-academiury-a-v-latin",
      "type": "pack",
      "name": "ACADEMIURY A&V - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "63",
        "64"
      ]
    },
    {
      "id": "pack:007-akademiuri-latin",
      "type": "pack",
      "name": "Akademiuri - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "70",
        "71"
      ]
    },
    {
      "id": "pack:008-akolkhetyn-latin",
      "type": "pack",
      "name": "AKolkhetyN - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "688",
        "689",
        "691",
        "690"
      ]
    },
    {
      "id": "pack:009-alk-rounded-unicode-utf-8",
      "type": "pack",
      "name": "ALK Rounded - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "685",
        "684"
      ]
    },
    {
      "id": "pack:010-alva-latin",
      "type": "pack",
      "name": "Alva - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "775",
        "774"
      ]
    },
    {
      "id": "pack:011-ar-archy-unicode-utf-8",
      "type": "pack",
      "name": "AR Archy - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "700",
        "696",
        "701",
        "702"
      ]
    },
    {
      "id": "pack:012-archy-edt-unicode-utf-8",
      "type": "pack",
      "name": "Archy EDT - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "744",
        "743"
      ]
    },
    {
      "id": "pack:013-arial-geo-unicode-utf-8",
      "type": "pack",
      "name": "Arial GEO - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "78",
        "721",
        "723",
        "722"
      ]
    },
    {
      "id": "pack:014-azacademiury-std8-geo-sp",
      "type": "pack",
      "name": "AZacademiury - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "84",
        "85",
        "87",
        "86"
      ]
    },
    {
      "id": "pack:015-babuka-latin",
      "type": "pack",
      "name": "Babuka - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "89",
        "90"
      ]
    },
    {
      "id": "pack:016-bakuri-unicode-utf-8",
      "type": "pack",
      "name": "Bakuri - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "906",
        "905"
      ]
    },
    {
      "id": "pack:017-bolnisi-latin",
      "type": "pack",
      "name": "Bolnisi - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "94",
        "95"
      ]
    },
    {
      "id": "pack:018-bpg-extrasquare-unicode-utf-8",
      "type": "pack",
      "name": "BPG ExtraSquare - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "14",
        "15"
      ]
    },
    {
      "id": "pack:019-bpg-glaho-unicode-utf-8",
      "type": "pack",
      "name": "BPG Glaho - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "1",
        "114"
      ]
    },
    {
      "id": "pack:020-bpg-phone-sans-unicode-utf-8",
      "type": "pack",
      "name": "BPG Phone Sans - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "489",
        "490",
        "491",
        "492"
      ]
    },
    {
      "id": "pack:021-bpg-serif-unicode-utf-8",
      "type": "pack",
      "name": "BPG Serif - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "179",
        "178"
      ]
    },
    {
      "id": "pack:022-chveulebrivi-td-latin",
      "type": "pack",
      "name": "Chveulebrivi TD - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "195",
        "194",
        "197",
        "196"
      ]
    },
    {
      "id": "pack:023-chveulebrivy-itv-latin",
      "type": "pack",
      "name": "Chveulebrivy-ITV - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "26",
        "27",
        "29",
        "28"
      ]
    },
    {
      "id": "pack:024-dara1981-mt-latin",
      "type": "pack",
      "name": "Dara1981-Mt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "788",
        "787"
      ]
    },
    {
      "id": "pack:025-dara1981-nus-latin",
      "type": "pack",
      "name": "Dara1981-Nus - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "786",
        "785"
      ]
    },
    {
      "id": "pack:026-dejavu-sans-unicode-utf-8",
      "type": "pack",
      "name": "DejaVu Sans - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 5,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "793",
        "795",
        "792",
        "796",
        "794"
      ]
    },
    {
      "id": "pack:027-dumbadze-itv-latin",
      "type": "pack",
      "name": "Dumbadze-ITV - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "34",
        "35",
        "37",
        "36"
      ]
    },
    {
      "id": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "type": "pack",
      "name": "Eurostile LT Std GEO_Mt - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 6,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "811",
        "813",
        "814",
        "815",
        "812",
        "810"
      ]
    },
    {
      "id": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "type": "pack",
      "name": "Eurostile LT Std GEO_Nus - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 6,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "805",
        "807",
        "808",
        "809",
        "806",
        "804"
      ]
    },
    {
      "id": "pack:030-g-g-ilia-latin",
      "type": "pack",
      "name": "G&G_Ilia - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "219",
        "218"
      ]
    },
    {
      "id": "pack:031-g-g-iliam-latin",
      "type": "pack",
      "name": "G&G_IliaM - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "220",
        "221"
      ]
    },
    {
      "id": "pack:032-g-g-illliam-latin",
      "type": "pack",
      "name": "G&G_IllliaM - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "223",
        "222"
      ]
    },
    {
      "id": "pack:033-g-g-kolhety-latin",
      "type": "pack",
      "name": "G&G_Kolhety - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "224",
        "225"
      ]
    },
    {
      "id": "pack:034-geo-acadmtavr-latin",
      "type": "pack",
      "name": "Geo AcadMtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "229",
        "230"
      ]
    },
    {
      "id": "pack:035-geo-acadnusx-latin",
      "type": "pack",
      "name": "Geo AcadNusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "232",
        "231"
      ]
    },
    {
      "id": "pack:036-geo-chveumtavr-latin",
      "type": "pack",
      "name": "Geo ChveuMtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "250",
        "249"
      ]
    },
    {
      "id": "pack:037-geo-chveunusx-latin",
      "type": "pack",
      "name": "Geo ChveuNusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "252",
        "251"
      ]
    },
    {
      "id": "pack:038-geo-dumbadze-mtavr-latin",
      "type": "pack",
      "name": "Geo Dumbadze Mtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 3,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "259",
        "260",
        "261"
      ]
    },
    {
      "id": "pack:039-geo-dumbadze-nusx-latin",
      "type": "pack",
      "name": "Geo Dumbadze Nusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 3,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "263",
        "264",
        "265"
      ]
    },
    {
      "id": "pack:040-geo-grigolia-mtavr-latin",
      "type": "pack",
      "name": "Geo Grigolia Mtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "277",
        "278"
      ]
    },
    {
      "id": "pack:041-geo-grigolia-nusx-latin",
      "type": "pack",
      "name": "Geo Grigolia Nusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "279",
        "280"
      ]
    },
    {
      "id": "pack:042-geo-grigoliapolygraph-latin",
      "type": "pack",
      "name": "Geo GrigoliaPolygraph - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "281",
        "282"
      ]
    },
    {
      "id": "pack:043-geo-ilia-mtavr-latin",
      "type": "pack",
      "name": "Geo Ilia Mtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "285",
        "284"
      ]
    },
    {
      "id": "pack:044-geo-ilia-nusx-latin",
      "type": "pack",
      "name": "Geo Ilia Nusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "287",
        "286"
      ]
    },
    {
      "id": "pack:045-geo-kolkheti-mtavr-latin",
      "type": "pack",
      "name": "Geo Kolkheti Mtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "296",
        "295"
      ]
    },
    {
      "id": "pack:046-geo-kolkheti-nusx-latin",
      "type": "pack",
      "name": "Geo Kolkheti Nusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "297",
        "298"
      ]
    },
    {
      "id": "pack:047-geo-literaturuly-n-std8-geo-sp",
      "type": "pack",
      "name": "Geo Literaturuly N - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "388",
        "390",
        "391",
        "389"
      ]
    },
    {
      "id": "pack:048-geo-litermtavr-latin",
      "type": "pack",
      "name": "Geo LiterMtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "303",
        "302"
      ]
    },
    {
      "id": "pack:049-geo-liternusx-latin",
      "type": "pack",
      "name": "Geo LiterNusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "305",
        "304"
      ]
    },
    {
      "id": "pack:050-latin",
      "type": "pack",
      "name": " - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "316",
        "16"
      ]
    },
    {
      "id": "pack:051-geodumba-latin",
      "type": "pack",
      "name": "GeoDumba - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 3,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "408",
        "410",
        "409"
      ]
    },
    {
      "id": "pack:052-geoedumba-latin",
      "type": "pack",
      "name": "GeoEDumba - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 3,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "413",
        "415",
        "414"
      ]
    },
    {
      "id": "pack:053-georgian-times-std8-geo-sp",
      "type": "pack",
      "name": "Georgian Times - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "421",
        "420"
      ]
    },
    {
      "id": "pack:054-geo-academiuri-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Academiuri - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "363",
        "364"
      ]
    },
    {
      "id": "pack:055-geo-arial-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Arial - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "366",
        "367",
        "369",
        "368"
      ]
    },
    {
      "id": "pack:056-geo-courier-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Courier - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "370",
        "371",
        "373",
        "372"
      ]
    },
    {
      "id": "pack:057-geo-dumbadze-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Dumbadze - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "374",
        "375"
      ]
    },
    {
      "id": "pack:058-geo-kolkheti-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Kolkheti - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "379",
        "380",
        "382",
        "381"
      ]
    },
    {
      "id": "pack:059-geo-literaturuli-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Literaturuli - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "384",
        "385",
        "387",
        "386"
      ]
    },
    {
      "id": "pack:060-geo-times-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Times - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "5",
        "10",
        "12",
        "11"
      ]
    },
    {
      "id": "pack:061-geo-venuri-std8-geo-sp",
      "type": "pack",
      "name": "Geo_Venuri - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "394",
        "395",
        "397",
        "396"
      ]
    },
    {
      "id": "pack:062-geo-www-courier-std8-geo-sp",
      "type": "pack",
      "name": "Geo_WWW_Courier - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "398",
        "399",
        "401",
        "400"
      ]
    },
    {
      "id": "pack:063-geo-www-times-std8-geo-sp",
      "type": "pack",
      "name": "Geo_WWW_Times - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "402",
        "403",
        "405",
        "404"
      ]
    },
    {
      "id": "pack:064-gf-aisi-mt-unicode-utf-8",
      "type": "pack",
      "name": "GF Aisi Mt - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "758",
        "760",
        "759",
        "757"
      ]
    },
    {
      "id": "pack:065-gf-aisi-mt-light-unicode-utf-8",
      "type": "pack",
      "name": "GF Aisi Mt Light - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "763",
        "764"
      ]
    },
    {
      "id": "pack:066-gf-aisi-mt-medium-unicode-utf-8",
      "type": "pack",
      "name": "GF Aisi Mt Medium - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "761",
        "762"
      ]
    },
    {
      "id": "pack:067-gf-aisi-nus-unicode-utf-8",
      "type": "pack",
      "name": "GF Aisi Nus - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "766",
        "768",
        "767",
        "765"
      ]
    },
    {
      "id": "pack:068-gf-aisi-nus-light-unicode-utf-8",
      "type": "pack",
      "name": "GF Aisi Nus Light - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "771",
        "772"
      ]
    },
    {
      "id": "pack:069-gf-aisi-nus-medium-unicode-utf-8",
      "type": "pack",
      "name": "GF Aisi Nus Medium - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "769",
        "770"
      ]
    },
    {
      "id": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "type": "pack",
      "name": "GF Alaverdi Mt - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 8,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "830",
        "831",
        "825",
        "827",
        "826",
        "828",
        "829",
        "824"
      ]
    },
    {
      "id": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "type": "pack",
      "name": "GF Alaverdi Nus - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 8,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "822",
        "823",
        "817",
        "819",
        "818",
        "820",
        "821",
        "816"
      ]
    },
    {
      "id": "pack:072-gf-satellite-17-mt-latin",
      "type": "pack",
      "name": "GF Satellite 17 Mt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "432",
        "433"
      ]
    },
    {
      "id": "pack:073-gf-satellite-2-mt-latin",
      "type": "pack",
      "name": "GF Satellite 2 Mt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "423",
        "424",
        "426",
        "425"
      ]
    },
    {
      "id": "pack:074-gf-satellite-28-mt-latin",
      "type": "pack",
      "name": "GF Satellite 28 Mt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "434",
        "435"
      ]
    },
    {
      "id": "pack:075-gf-satellite-3-mt-latin",
      "type": "pack",
      "name": "GF Satellite 3 Mt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "427",
        "428"
      ]
    },
    {
      "id": "pack:076-gf-satellite-6-mt-latin",
      "type": "pack",
      "name": "GF Satellite 6 Mt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 3,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "429",
        "430",
        "431"
      ]
    },
    {
      "id": "pack:077-gl-lortkipanidze-unicode-utf-8",
      "type": "pack",
      "name": "GL Lortkipanidze - Unicode (UTF-8)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "861",
        "860"
      ]
    },
    {
      "id": "pack:078-gogebashvili-itv-latin",
      "type": "pack",
      "name": "Gogebashvili-ITV - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "38",
        "39",
        "41",
        "40"
      ]
    },
    {
      "id": "pack:079-grigoliapolygraph-latin",
      "type": "pack",
      "name": "GrigoliaPolygraph - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "449",
        "450"
      ]
    },
    {
      "id": "pack:080-hkolkhetymtav-latin",
      "type": "pack",
      "name": "HKolkhetyMtav - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "464",
        "465"
      ]
    },
    {
      "id": "pack:081-kolkhety-latin",
      "type": "pack",
      "name": "Kolkhety - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "473",
        "474"
      ]
    },
    {
      "id": "pack:082-kolkhety-itv-latin",
      "type": "pack",
      "name": "Kolkhety-ITV - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "42",
        "43",
        "45",
        "44"
      ]
    },
    {
      "id": "pack:083-literaturuli-td-latin",
      "type": "pack",
      "name": "Literaturuli-TD - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "478",
        "479",
        "481",
        "480"
      ]
    },
    {
      "id": "pack:084-literaturuly-itv-latin",
      "type": "pack",
      "name": "Literaturuly-ITV - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 4,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "46",
        "47",
        "49",
        "48"
      ]
    },
    {
      "id": "pack:085-litermtavr-latin",
      "type": "pack",
      "name": "LiterMtavr - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "659",
        "660"
      ]
    },
    {
      "id": "pack:086-liternusx-latin",
      "type": "pack",
      "name": "LiterNusx - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "658",
        "657"
      ]
    },
    {
      "id": "pack:087-metroff-latin",
      "type": "pack",
      "name": "metroff - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "496",
        "628"
      ]
    },
    {
      "id": "pack:088-sokolxety-latin",
      "type": "pack",
      "name": "SokolxeTy - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "520",
        "521"
      ]
    },
    {
      "id": "pack:089-spacademi-std8-geo-sp",
      "type": "pack",
      "name": "SPAcademi - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "522",
        "523"
      ]
    },
    {
      "id": "pack:090-spacademi-mt-std8-geo-sp",
      "type": "pack",
      "name": "SPAcademi MT - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "525",
        "524"
      ]
    },
    {
      "id": "pack:091-spchveulebrivi-std8-geo-sp",
      "type": "pack",
      "name": "SPChveulebrivi - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "528",
        "527"
      ]
    },
    {
      "id": "pack:092-spchveulebrivimt-std8-geo-sp",
      "type": "pack",
      "name": "SPChveulebriviMT - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "530",
        "529"
      ]
    },
    {
      "id": "pack:093-spgrigolia-std8-geo-sp",
      "type": "pack",
      "name": "SPGrigolia - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "537",
        "538"
      ]
    },
    {
      "id": "pack:094-spgrigolia-mt-std8-geo-sp",
      "type": "pack",
      "name": "SPGrigolia MT - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "539",
        "540"
      ]
    },
    {
      "id": "pack:095-spkolheti-std8-geo-sp",
      "type": "pack",
      "name": "SPKolheti - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "543",
        "542"
      ]
    },
    {
      "id": "pack:096-spkolhetimt-std8-geo-sp",
      "type": "pack",
      "name": "SPKolhetiMT - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "545",
        "544"
      ]
    },
    {
      "id": "pack:097-spliteraturuly-std8-geo-sp",
      "type": "pack",
      "name": "SPLiteraturuly - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "546",
        "547"
      ]
    },
    {
      "id": "pack:098-spparliament-std8-geo-sp",
      "type": "pack",
      "name": "SPParliament - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "552",
        "551"
      ]
    },
    {
      "id": "pack:099-spparliamentmt-std8-geo-sp",
      "type": "pack",
      "name": "SPParliamentMT - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "554",
        "553"
      ]
    },
    {
      "id": "pack:100-spsiradze-std8-geo-sp",
      "type": "pack",
      "name": "SPSiradze - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "558",
        "559"
      ]
    },
    {
      "id": "pack:101-spvena-std8-geo-sp",
      "type": "pack",
      "name": "SPVena - STD8 (Geo, SP)",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "561",
        "560"
      ]
    },
    {
      "id": "pack:102-titus-mxedruli-latin",
      "type": "pack",
      "name": "Titus Mxedruli - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "615",
        "614"
      ]
    },
    {
      "id": "pack:103-kolhetymt-latin",
      "type": "pack",
      "name": "_! KolhetyMt - Latin",
      "kind": "family",
      "description": "Matching catalog family, author, encoding and keyboard layout. Only styles present in our library are included.",
      "fontCount": 2,
      "status": "draft",
      "groupingBasis": [
        "family",
        "encoding",
        "keyboard-layout",
        "authors"
      ],
      "fontIds": [
        "736",
        "735"
      ]
    }
  ],
  "fonts": [
    {
      "id": "font:727",
      "name": "ALK Life",
      "family": "ALK Life",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/727/ALK-Life",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c1b9b36291b54323fcb2fcb6772b0814d6e87e88a1534fdcabc47f27ebe60391",
      "type": "font",
      "file": "fonts/727.otf",
      "catalogId": "727"
    },
    {
      "id": "font:696",
      "name": "AR Archy Regular",
      "family": "AR Archy",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Akaki Razmadze"
      ],
      "source": "https://fonts.ge/en/font/696/AR-Archy-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "150dee67b4a7ea2e8269323bb1e91dfaa7e87284774650aea2887f21f4a869d4",
      "type": "font",
      "file": "fonts/696.ttf",
      "catalogId": "696"
    },
    {
      "id": "font:703",
      "name": "ALK Katerina",
      "family": "ALK Katerina",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/703/ALK-Katerina",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a4a54b2c3ddd0e0271b34ba6ac609aaf4c2ed1ffc7088af5a363603b34123ec6",
      "type": "font",
      "file": "fonts/703.ttf",
      "catalogId": "703"
    },
    {
      "id": "font:704",
      "name": "ALK Sanet",
      "family": "ALK Sanet",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/704/ALK-Sanet",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "bfb1b31dd96e9220078924eef98433d27c99975b1efe87598e8431097868f8de",
      "type": "font",
      "file": "fonts/704.ttf",
      "catalogId": "704"
    },
    {
      "id": "font:905",
      "name": "Bakuri Regular",
      "family": "Bakuri",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bakur Javakhadze"
      ],
      "source": "https://fonts.ge/en/font/905/Bakuri-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f84cc6250f192f4a9c00100202fff36125a86762a53a7383e80eae9cd15cfc74",
      "type": "font",
      "file": "fonts/905.ttf",
      "catalogId": "905"
    },
    {
      "id": "font:906",
      "name": "Bakuri Italic",
      "family": "Bakuri",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bakur Javakhadze"
      ],
      "source": "https://fonts.ge/en/font/906/Bakuri-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "025bba4c9719076ad9884d064bcde5b11395733eacb5656a862eed38a32fac09",
      "type": "font",
      "file": "fonts/906.ttf",
      "catalogId": "906"
    },
    {
      "id": "font:705",
      "name": "ALK Rex Bold",
      "family": "ALK Rex",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/705/ALK-Rex-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "bd9a20ffddb805253836d904a489943618a7b6fc77c7c8e34e299eeff3940f47",
      "type": "font",
      "file": "fonts/705.otf",
      "catalogId": "705"
    },
    {
      "id": "font:707",
      "name": "ALK Tall Mtavruli Regular",
      "family": "ALK Tall Mtavruli",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/707/ALK-Tall-Mtavruli-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0ae23c249547bb409da6f624c35d2c259a6d414e81f519021c13fe20ff5fbcfd",
      "type": "font",
      "file": "fonts/707.otf",
      "catalogId": "707"
    },
    {
      "id": "font:708",
      "name": "ALK Tall Nusxuri Regular",
      "family": "ALK Tall Nusxuri",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/708/ALK-Tall-Nusxuri-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c8f14e5ff717573860159d41cf5291887ddfec0df767b9996d5e5cde26c9d256",
      "type": "font",
      "file": "fonts/708.otf",
      "catalogId": "708"
    },
    {
      "id": "font:712",
      "name": "BPG Banner",
      "family": "BPG Banner",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/712/BPG-Banner",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "75dd6e7c2270734c8b416f2454ab9d1c473a8403068389589e70c319a074ba35",
      "type": "font",
      "file": "fonts/712.ttf",
      "catalogId": "712"
    },
    {
      "id": "font:715",
      "name": "BPG Banner ExtraSquare",
      "family": "BPG Banner ExtraSquare",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/715/BPG-Banner-ExtraSquare",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "75af7af6b89ad54229df4d962431d7642157976c94edf69a0b5b60470ebe0baa",
      "type": "font",
      "file": "fonts/715.ttf",
      "catalogId": "715"
    },
    {
      "id": "font:719",
      "name": "BPG Banner SuperSquare",
      "family": "BPG Banner SuperSquare",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/719/BPG-Banner-SuperSquare",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "448fb75be5d62a35e8d477dc6a9f57c468f21bf1b053e09ea804180cbea0c324",
      "type": "font",
      "file": "fonts/719.ttf",
      "catalogId": "719"
    },
    {
      "id": "font:700",
      "name": "AR Archy ExtraLight",
      "family": "AR Archy",
      "style": "ExtraLight",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Akaki Razmadze"
      ],
      "source": "https://fonts.ge/en/font/700/AR-Archy-ExtraLight",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7bca1e28dc47ee98905d8e75d8a7ce1d70e8e93c9532fffbecfa12179d1c8d92",
      "type": "font",
      "file": "fonts/700.ttf",
      "catalogId": "700"
    },
    {
      "id": "font:701",
      "name": "AR Archy SemiBold",
      "family": "AR Archy",
      "style": "SemiBold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Akaki Razmadze"
      ],
      "source": "https://fonts.ge/en/font/701/AR-Archy-SemiBold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9a5604807e3d426068ba7692028a4e6e7db46a5c4c09f642ed21ac6736b98b2d",
      "type": "font",
      "file": "fonts/701.ttf",
      "catalogId": "701"
    },
    {
      "id": "font:702",
      "name": "AR Archy Thin",
      "family": "AR Archy",
      "style": "Thin",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Akaki Razmadze"
      ],
      "source": "https://fonts.ge/en/font/702/AR-Archy-Thin",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "49a8b8beb4c3e29d24bac17af49a114bdccc71bb3ba4269ab976bea0040362df",
      "type": "font",
      "file": "fonts/702.ttf",
      "catalogId": "702"
    },
    {
      "id": "font:713",
      "name": "BPG Banner Caps",
      "family": "BPG Banner Caps",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/713/BPG-Banner-Caps",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ec162b9be88e03a7928195b8c910b55153c38284b609d14b2ab8b540101c11c4",
      "type": "font",
      "file": "fonts/713.ttf",
      "catalogId": "713"
    },
    {
      "id": "font:714",
      "name": "BPG Banner Caps Alpha",
      "family": "BPG Banner Caps Alpha",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/714/BPG-Banner-Caps-Alpha",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "02b49d295823f8b0928adf0e061382620d322d0a13a1ee4b825f1c8401f92be2",
      "type": "font",
      "file": "fonts/714.ttf",
      "catalogId": "714"
    },
    {
      "id": "font:716",
      "name": "BPG Banner ExtraSquare Caps",
      "family": "BPG Banner ExtraSquare Caps",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/716/BPG-Banner-ExtraSquare-Caps",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9fc049a7e3e145f326f84588d88af373b6f0be03f13bfdbaecc6239e2d5168b6",
      "type": "font",
      "file": "fonts/716.ttf",
      "catalogId": "716"
    },
    {
      "id": "font:717",
      "name": "BPG Banner QuadroSquare",
      "family": "BPG Banner QuadroSquare",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/717/BPG-Banner-QuadroSquare",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "04daa03a3889412d1d0b6aefeff30f0765fb4b84cceec56453c84bc0d23f88d2",
      "type": "font",
      "file": "fonts/717.ttf",
      "catalogId": "717"
    },
    {
      "id": "font:718",
      "name": "BPG Banner QuadroSquare Caps",
      "family": "BPG Banner QuadroSquare Caps",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/718/BPG-Banner-QuadroSquare-Caps",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7215a38461ca6eedc5bf04719187313cd483012e111e5cbebb63fead9c597a65",
      "type": "font",
      "file": "fonts/718.ttf",
      "catalogId": "718"
    },
    {
      "id": "font:720",
      "name": "BPG Banner SuperSquare Caps",
      "family": "BPG Banner SuperSquare Caps",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/720/BPG-Banner-SuperSquare-Caps",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "99aea0c79c0e642ab60275c4eb9c8a22f8821015931a158f9b89f952a0006f27",
      "type": "font",
      "file": "fonts/720.ttf",
      "catalogId": "720"
    },
    {
      "id": "font:56",
      "name": "AAAcademiury Bold",
      "family": "AAAcademiury",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Zura Akhaladze"
      ],
      "source": "https://fonts.ge/en/font/56/AAAcademiury-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "04d8b3dc2754b4609aa93aa56cfccea6959d75a054e7b8753c8a12d82bf579ba",
      "type": "font",
      "file": "fonts/56.ttf",
      "catalogId": "56"
    },
    {
      "id": "font:57",
      "name": "AAAcademiury Italic",
      "family": "AAAcademiury",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Zura Akhaladze"
      ],
      "source": "https://fonts.ge/en/font/57/AAAcademiury-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4e1e016f0297159af92a055901400b74a5a12a061f33beedd7b6b95344ff98bb",
      "type": "font",
      "file": "fonts/57.ttf",
      "catalogId": "57"
    },
    {
      "id": "font:63",
      "name": "ACADEMIURY A&V",
      "family": "ACADEMIURY A&V",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alex Gurgenidze",
        "Victor Gurgenidze"
      ],
      "source": "https://fonts.ge/en/font/63/ACADEMIURY-A%26V",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b1db890bd0a3bedb19384220504c2f99f09d73cf68527e496c45f30ab7e6034d",
      "type": "font",
      "file": "fonts/63.ttf",
      "catalogId": "63"
    },
    {
      "id": "font:64",
      "name": "ACADEMIURY A&V Bold",
      "family": "ACADEMIURY A&V",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alex Gurgenidze",
        "Victor Gurgenidze"
      ],
      "source": "https://fonts.ge/en/font/64/ACADEMIURY-A%26V-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e9fe7b4db17e33532f329fce641be22e2f331b680edec57194690c18a1a4ed69",
      "type": "font",
      "file": "fonts/64.ttf",
      "catalogId": "64"
    },
    {
      "id": "font:70",
      "name": "Akademiuri",
      "family": "Akademiuri",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Lado Kuchava"
      ],
      "source": "https://fonts.ge/en/font/70/Akademiuri",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "31b54ccf678cea4dac58c05ac115b85502901052b0ed87c7c650b2e6d0f9a300",
      "type": "font",
      "file": "fonts/70.ttf",
      "catalogId": "70"
    },
    {
      "id": "font:71",
      "name": "Akademiuri mtavruli",
      "family": "Akademiuri",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Lado Kuchava"
      ],
      "source": "https://fonts.ge/en/font/71/Akademiuri-mtavruli",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "692b436c489238363ace2b66a33de9225117ba32a4d93144a539dcf4aeb23ed0",
      "type": "font",
      "file": "fonts/71.ttf",
      "catalogId": "71"
    },
    {
      "id": "font:688",
      "name": "AKolkhetyN",
      "family": "AKolkhetyN",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Sandro Asatiani"
      ],
      "source": "https://fonts.ge/en/font/688/AKolkhetyN",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "824fc5eaf5611c4649ed6933e6786784e3a54d96b623b4b8323aa36aa785a6dc",
      "type": "font",
      "file": "fonts/688.otf",
      "catalogId": "688"
    },
    {
      "id": "font:689",
      "name": "AKolkhetyN Bold",
      "family": "AKolkhetyN",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Sandro Asatiani"
      ],
      "source": "https://fonts.ge/en/font/689/AKolkhetyN-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "97ba59c5c8f21b5cfac6b4eaf6a71435332b427f3867904a9ea253641690bc48",
      "type": "font",
      "file": "fonts/689.otf",
      "catalogId": "689"
    },
    {
      "id": "font:691",
      "name": "AKolkhetyN Bold Italic",
      "family": "AKolkhetyN",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Sandro Asatiani"
      ],
      "source": "https://fonts.ge/en/font/691/AKolkhetyN-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e72368c92e5b86312d8a7765fc1a8d42772df7d745a4fbcf1950d269f8bd4680",
      "type": "font",
      "file": "fonts/691.otf",
      "catalogId": "691"
    },
    {
      "id": "font:690",
      "name": "AKolkhetyN Italic",
      "family": "AKolkhetyN",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Sandro Asatiani"
      ],
      "source": "https://fonts.ge/en/font/690/AKolkhetyN-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2c18ec95dec2edfe4f3143d8659736607cc0d12ea0380e83888e9d1f13bb3adb",
      "type": "font",
      "file": "fonts/690.otf",
      "catalogId": "690"
    },
    {
      "id": "font:685",
      "name": "ALK Rounded Mtav Med",
      "family": "ALK Rounded",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/685/ALK-Rounded-Mtav-Med",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f03ff676d7cb6ee5bd6c4d1cdf2e291b49f70673fda252adb9e8c9acea48e790",
      "type": "font",
      "file": "fonts/685.otf",
      "catalogId": "685"
    },
    {
      "id": "font:684",
      "name": "ALK Rounded Nusx Med",
      "family": "ALK Rounded",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Alexander Sukiasov"
      ],
      "source": "https://fonts.ge/en/font/684/ALK-Rounded-Nusx-Med",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b84fa35e10a61dd19be870440832064975f873de4d670d92e89a46fc3d75802d",
      "type": "font",
      "file": "fonts/684.otf",
      "catalogId": "684"
    },
    {
      "id": "font:775",
      "name": "Alva Bold",
      "family": "Alva",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Rati Tordia"
      ],
      "source": "https://fonts.ge/en/font/775/Alva-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2e84705a13e3d8393267d19306e9474394d450e8886b564c0c7df8ea55592375",
      "type": "font",
      "file": "fonts/775.ttf",
      "catalogId": "775"
    },
    {
      "id": "font:774",
      "name": "Alva Normal",
      "family": "Alva",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Rati Tordia"
      ],
      "source": "https://fonts.ge/en/font/774/Alva-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e3769199ebb2bb9ef40270e9ff4948d81b455e0240aca5d837cf97aab07d309d",
      "type": "font",
      "file": "fonts/774.ttf",
      "catalogId": "774"
    },
    {
      "id": "font:744",
      "name": "ArchyEDT-Bold",
      "family": "Archy EDT",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Akaki Razmadze"
      ],
      "source": "https://fonts.ge/en/font/744/ArchyEDT-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "70ddd3677000d4b7b80d0ebefefa9250adc4c442fa941213d7a826622be75eca",
      "type": "font",
      "file": "fonts/744.otf",
      "catalogId": "744"
    },
    {
      "id": "font:743",
      "name": "ArchyEDT-Thin",
      "family": "Archy EDT",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Akaki Razmadze"
      ],
      "source": "https://fonts.ge/en/font/743/ArchyEDT-Thin",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5cc5ccf2f44981209e963da7474a6f6760dc37078c34eb364812b3a6b72e2a9c",
      "type": "font",
      "file": "fonts/743.otf",
      "catalogId": "743"
    },
    {
      "id": "font:78",
      "name": "Arial GEO",
      "family": "Arial GEO",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/78/Arial-GEO",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0109bd426493bce0d65e5027e446a471d8f5171fc4ff3c660182efd93d6dbaf6",
      "type": "font",
      "file": "fonts/78.ttf",
      "catalogId": "78"
    },
    {
      "id": "font:721",
      "name": "Arial GEO Bold",
      "family": "Arial GEO",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/721/Arial-GEO-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f3516ab9cd80df4aedd7e28063051fe93d4042a14e93cdb0ec1ea0fd0174d19e",
      "type": "font",
      "file": "fonts/721.ttf",
      "catalogId": "721"
    },
    {
      "id": "font:723",
      "name": "Arial GEO BoldItalic",
      "family": "Arial GEO",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/723/Arial-GEO-BoldItalic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "621fb27c8d1137e86d33b4ad1cfca95f8ba33837af531f572fae104ac814a864",
      "type": "font",
      "file": "fonts/723.ttf",
      "catalogId": "723"
    },
    {
      "id": "font:722",
      "name": "Arial GEO Italic",
      "family": "Arial GEO",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/722/Arial-GEO-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7070e454541a28a31e28ad5c7147dc5c86b5850be974256a3c05d38965df67bf",
      "type": "font",
      "file": "fonts/722.ttf",
      "catalogId": "722"
    },
    {
      "id": "font:84",
      "name": "AZacademiury",
      "family": "AZacademiury",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/84/AZacademiury",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7d9996637b6ec8107cb126ab19ccab8459044a3eceb524b1fdd7334cedd55400",
      "type": "font",
      "file": "fonts/84.ttf",
      "catalogId": "84"
    },
    {
      "id": "font:85",
      "name": "AZacademiury Bold",
      "family": "AZacademiury",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/85/AZacademiury-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "69bce253608aaf4c18e258c1584fdbbb8d8a51f60ec2b2b972de6cdb5feb2025",
      "type": "font",
      "file": "fonts/85.ttf",
      "catalogId": "85"
    },
    {
      "id": "font:87",
      "name": "AZacademiury Bold Italic",
      "family": "AZacademiury",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/87/AZacademiury-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "74c5b2dff0d0da29aef2cdcdf1187ce8cd515bcbc8ba4704e1553b665a8d3b4f",
      "type": "font",
      "file": "fonts/87.ttf",
      "catalogId": "87"
    },
    {
      "id": "font:86",
      "name": "AZacademiury Italic",
      "family": "AZacademiury",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/86/AZacademiury-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e8fc9721dd2b5aff9d8a6065fd4c30b31146607b7b604e8d05f319b4f23f60d8",
      "type": "font",
      "file": "fonts/86.ttf",
      "catalogId": "86"
    },
    {
      "id": "font:89",
      "name": "Babuka",
      "family": "Babuka",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Slava Meskhi"
      ],
      "source": "https://fonts.ge/en/font/89/Babuka",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "84f5765337d5573a6eb57a08b53bb72cbc4c1ae0fc3624454973b4e7c729e78b",
      "type": "font",
      "file": "fonts/89.ttf",
      "catalogId": "89"
    },
    {
      "id": "font:90",
      "name": "Babuka Mtavruli",
      "family": "Babuka",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Slava Meskhi"
      ],
      "source": "https://fonts.ge/en/font/90/Babuka-Mtavruli",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "dbc0b6dfd81f33d11324fd4851080757523e88ec0ac652bfc78c784a296002f8",
      "type": "font",
      "file": "fonts/90.ttf",
      "catalogId": "90"
    },
    {
      "id": "font:94",
      "name": "Bolnisi",
      "family": "Bolnisi",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Slava Meskhi"
      ],
      "source": "https://fonts.ge/en/font/94/Bolnisi",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7d02b8ce3e16e062e4672e49a9b33a0e8732782e0ec6b750645480a925e7b1d9",
      "type": "font",
      "file": "fonts/94.ttf",
      "catalogId": "94"
    },
    {
      "id": "font:95",
      "name": "Bolnisi Mtavruli",
      "family": "Bolnisi",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Slava Meskhi"
      ],
      "source": "https://fonts.ge/en/font/95/Bolnisi-Mtavruli",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "cbef0c7561e5ce6dfe44131e73e8f48a9391386853524058d5d171d01e657988",
      "type": "font",
      "file": "fonts/95.ttf",
      "catalogId": "95"
    },
    {
      "id": "font:14",
      "name": "BPG ExtraSquare",
      "family": "BPG ExtraSquare",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/14/BPG-ExtraSquare",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "84fde51e0aef454907d190c6de613ae6dec55c1120c1d7be5ad6f59dd62def6b",
      "type": "font",
      "file": "fonts/14.ttf",
      "catalogId": "14"
    },
    {
      "id": "font:15",
      "name": "BPG ExtraSquare Mtavruli",
      "family": "BPG ExtraSquare",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/15/BPG-ExtraSquare-Mtavruli",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d19244afb013eeeae335c51738a003905188c5250053fdfafa509c2fa7e5ec25",
      "type": "font",
      "file": "fonts/15.ttf",
      "catalogId": "15"
    },
    {
      "id": "font:1",
      "name": "BPG Glaho",
      "family": "BPG Glaho",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/1/BPG-Glaho",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8861e9b32857a6c8ea0b213cfc7c4e76ff20b55aa1e2bc3aab40610231306a14",
      "type": "font",
      "file": "fonts/1.ttf",
      "catalogId": "1"
    },
    {
      "id": "font:114",
      "name": "BPG Glaho Bold",
      "family": "BPG Glaho",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/114/BPG-Glaho-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e1fa4723fbae04b0ff795f49fca4bbb84d8ecea5d4f1800301ab46dc12947fb5",
      "type": "font",
      "file": "fonts/114.ttf",
      "catalogId": "114"
    },
    {
      "id": "font:489",
      "name": "BPG Phone Sans",
      "family": "BPG Phone Sans",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/489/BPG-Phone-Sans",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "dfba95f9506a63a45c9965083a66fcd88c2177fb12aba3d04cd1a63cd2737a44",
      "type": "font",
      "file": "fonts/489.ttf",
      "catalogId": "489"
    },
    {
      "id": "font:490",
      "name": "BPG Phone Sans Bold",
      "family": "BPG Phone Sans",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/490/BPG-Phone-Sans-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "6d47a54ec95c5113bd0ffc2d4c9adc24e5770c553e49c142122d5831e00e6e40",
      "type": "font",
      "file": "fonts/490.ttf",
      "catalogId": "490"
    },
    {
      "id": "font:491",
      "name": "BPG Phone Sans Bold Italic",
      "family": "BPG Phone Sans",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/491/BPG-Phone-Sans-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9c61c5559017a31a107c9494f09f94c09b6b50993fd769be3d678529b7b5fd24",
      "type": "font",
      "file": "fonts/491.ttf",
      "catalogId": "491"
    },
    {
      "id": "font:492",
      "name": "BPG Phone Sans Italic",
      "family": "BPG Phone Sans",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/492/BPG-Phone-Sans-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "80901f18249f457b57f8cc77c7c7efd973174ad9b61755a2fa53b9f8c0597d61",
      "type": "font",
      "file": "fonts/492.ttf",
      "catalogId": "492"
    },
    {
      "id": "font:179",
      "name": "BPG Serif (w cyrillic)",
      "family": "BPG Serif",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/179/BPG-Serif-%28w-cyrillic%29",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a2337b2b165bfa7663e2cf0b7978d389280f9fb0eb94578b1188b27201eeb5ef",
      "type": "font",
      "file": "fonts/179.ttf",
      "catalogId": "179"
    },
    {
      "id": "font:178",
      "name": "BPG Serif (wo cyrillic)",
      "family": "BPG Serif",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Besarion Gugushvili"
      ],
      "source": "https://fonts.ge/en/font/178/BPG-Serif-%28wo-cyrillic%29",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5e047d35c78bee146a559715a4f3db6e39074051d99ad15277f7f1e5e295d602",
      "type": "font",
      "file": "fonts/178.ttf",
      "catalogId": "178"
    },
    {
      "id": "font:195",
      "name": "Chveulebrivi TD",
      "family": "Chveulebrivi TD",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/195/Chveulebrivi-TD",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5518b53900d4b979805316a1882ef58a95a5fc4e137a6798b354a39de980c626",
      "type": "font",
      "file": "fonts/195.ttf",
      "catalogId": "195"
    },
    {
      "id": "font:194",
      "name": "Chveulebrivi TD Bold",
      "family": "Chveulebrivi TD",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/194/Chveulebrivi-TD-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "cdc17ffad5f043c01e0da6d06dd385b2d2fc9126234e65b53604f24194d2dbec",
      "type": "font",
      "file": "fonts/194.ttf",
      "catalogId": "194"
    },
    {
      "id": "font:197",
      "name": "Chveulebrivi TD Bold-Italic",
      "family": "Chveulebrivi TD",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/197/Chveulebrivi-TD-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8ce7be5bdf10ccb5c4c1e650a15e0c2a4170b6bc6ed03db58f82d2dd7703783f",
      "type": "font",
      "file": "fonts/197.ttf",
      "catalogId": "197"
    },
    {
      "id": "font:196",
      "name": "Chveulebrivi TD Italic",
      "family": "Chveulebrivi TD",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/196/Chveulebrivi-TD-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "80219fc21021f8691de1bd6a7acbcbd9144cf97e563f8171f42874b85cedd255",
      "type": "font",
      "file": "fonts/196.ttf",
      "catalogId": "196"
    },
    {
      "id": "font:26",
      "name": "Chveulebrivy-ITV",
      "family": "Chveulebrivy-ITV",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/26/Chveulebrivy-ITV",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "681ed234df0d265391297f363d6951f4685d54d7f604fa3ab74585f41e4a5c78",
      "type": "font",
      "file": "fonts/26.ttf",
      "catalogId": "26"
    },
    {
      "id": "font:27",
      "name": "Chveulebrivy-ITV Bold",
      "family": "Chveulebrivy-ITV",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/27/Chveulebrivy-ITV-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ab09b48853b07a0824de469f19e37bcb55419881d0daf2a592a9cd3b585bd2c4",
      "type": "font",
      "file": "fonts/27.ttf",
      "catalogId": "27"
    },
    {
      "id": "font:29",
      "name": "Chveulebrivy-ITV Bold Italic",
      "family": "Chveulebrivy-ITV",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/29/Chveulebrivy-ITV-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3a6e0f53386064eff69b6429c0bf7f9eaf07e1c967ec457786ed005cc0b9d3cb",
      "type": "font",
      "file": "fonts/29.ttf",
      "catalogId": "29"
    },
    {
      "id": "font:28",
      "name": "Chveulebrivy-ITV Italic",
      "family": "Chveulebrivy-ITV",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/28/Chveulebrivy-ITV-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9b3774457cadd8a1f40651a5e364228f90e7ccad938df7cb74610ba94afd16c4",
      "type": "font",
      "file": "fonts/28.ttf",
      "catalogId": "28"
    },
    {
      "id": "font:788",
      "name": "Dara1981-Mt Bold",
      "family": "Dara1981-Mt",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Ia Darakhvelidze",
        "Temur Darakhvelidze"
      ],
      "source": "https://fonts.ge/en/font/788/Dara1981-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e5195e74f5bfe31a8c9175072fbb3578446028af8b47d1207dc2f5592a1bafe3",
      "type": "font",
      "file": "fonts/788.otf",
      "catalogId": "788"
    },
    {
      "id": "font:787",
      "name": "Dara1981-Mt Regular",
      "family": "Dara1981-Mt",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Ia Darakhvelidze",
        "Temur Darakhvelidze"
      ],
      "source": "https://fonts.ge/en/font/787/Dara1981-Mt-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "314260f35a9df2b389e14cc354a7901ad06b1fcc66d532ab5ec31ab148a4dcfc",
      "type": "font",
      "file": "fonts/787.otf",
      "catalogId": "787"
    },
    {
      "id": "font:786",
      "name": "Dara1981-Nus Bold",
      "family": "Dara1981-Nus",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Ia Darakhvelidze",
        "Temur Darakhvelidze"
      ],
      "source": "https://fonts.ge/en/font/786/Dara1981-Nus-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "91190add8a95a137db7c912f38147b463ba83ecae63822e469f62c3390b47091",
      "type": "font",
      "file": "fonts/786.otf",
      "catalogId": "786"
    },
    {
      "id": "font:785",
      "name": "Dara1981-Nus Regular",
      "family": "Dara1981-Nus",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Ia Darakhvelidze",
        "Temur Darakhvelidze"
      ],
      "source": "https://fonts.ge/en/font/785/Dara1981-Nus-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "95eec05d70731aa528c3362c38e419fa8e7b5b57149678507b491f81cd1eb0ca",
      "type": "font",
      "file": "fonts/785.otf",
      "catalogId": "785"
    },
    {
      "id": "font:793",
      "name": "DejaVu Sans Bold",
      "family": "DejaVu Sans",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bitstream"
      ],
      "source": "https://fonts.ge/en/font/793/DejaVu-Sans-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e6476c1b80502924294eed40894c5b18e06c181444ca953e5334262df9c27724",
      "type": "font",
      "file": "fonts/793.ttf",
      "catalogId": "793"
    },
    {
      "id": "font:795",
      "name": "DejaVu Sans Bold Oblique",
      "family": "DejaVu Sans",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bitstream"
      ],
      "source": "https://fonts.ge/en/font/795/DejaVu-Sans-Bold-Oblique",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "eb436dca0c2594b73d8b603b892e374fdfd8d885d25ffb4f18df4c4c0b49e50f",
      "type": "font",
      "file": "fonts/795.ttf",
      "catalogId": "795"
    },
    {
      "id": "font:792",
      "name": "DejaVu Sans Book",
      "family": "DejaVu Sans",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bitstream"
      ],
      "source": "https://fonts.ge/en/font/792/DejaVu-Sans-Book",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7da195a74c55bef988d0d48f9508bd5d849425c1770dba5d7bfc6ce9ed848954",
      "type": "font",
      "file": "fonts/792.ttf",
      "catalogId": "792"
    },
    {
      "id": "font:796",
      "name": "DejaVu Sans ExtraLight",
      "family": "DejaVu Sans",
      "style": "ExtraLight",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bitstream"
      ],
      "source": "https://fonts.ge/en/font/796/DejaVu-Sans-ExtraLight",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "6cb0746a1f68d176bebe83752cee35ebdf726cb1a1e88a01fc038ddf76de9ea8",
      "type": "font",
      "file": "fonts/796.ttf",
      "catalogId": "796"
    },
    {
      "id": "font:794",
      "name": "DejaVu Sans Oblique",
      "family": "DejaVu Sans",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Bitstream"
      ],
      "source": "https://fonts.ge/en/font/794/DejaVu-Sans-Oblique",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4af75fa16ee6d3ad43e1ecec41862c24954af26a55c6bb1ebb27bd486a50f5f4",
      "type": "font",
      "file": "fonts/794.ttf",
      "catalogId": "794"
    },
    {
      "id": "font:34",
      "name": "Dumbadze-ITV",
      "family": "Dumbadze-ITV",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/34/Dumbadze-ITV",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d290bb2227f7b8b089663a001d2be5ffa40946e29e0a5808fcd3173d6e54787b",
      "type": "font",
      "file": "fonts/34.ttf",
      "catalogId": "34"
    },
    {
      "id": "font:35",
      "name": "Dumbadze-ITV Bold",
      "family": "Dumbadze-ITV",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/35/Dumbadze-ITV-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ee97ec54b8b1a0a7816a31da93fcd2fe0dcae0b20ed19a36d52c3176078c0f60",
      "type": "font",
      "file": "fonts/35.ttf",
      "catalogId": "35"
    },
    {
      "id": "font:37",
      "name": "Dumbadze-ITV Bold Italic",
      "family": "Dumbadze-ITV",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/37/Dumbadze-ITV-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "841f2b2cc8b02d28ca7ecb36844a3df0cb93d83aced6402d15f9f29094b9cc22",
      "type": "font",
      "file": "fonts/37.ttf",
      "catalogId": "37"
    },
    {
      "id": "font:36",
      "name": "Dumbadze-ITV Italic",
      "family": "Dumbadze-ITV",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/36/Dumbadze-ITV-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "6803b923b4cf243b253953afcbb524cab919994d05529f32cc5a819d005628a8",
      "type": "font",
      "file": "fonts/36.ttf",
      "catalogId": "36"
    },
    {
      "id": "font:811",
      "name": "Eurostile LT Std GEO_Mt Bold",
      "family": "Eurostile LT Std GEO_Mt",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/811/Eurostile-LT-Std-GEO-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e9031d1c421cacdbe286345700811e65e1dab119491c02cb46043620cd70c3e7",
      "type": "font",
      "file": "fonts/811.ttf",
      "catalogId": "811"
    },
    {
      "id": "font:813",
      "name": "Eurostile LT Std GEO_Mt Bold Italic",
      "family": "Eurostile LT Std GEO_Mt",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/813/Eurostile-LT-Std-GEO-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e28cd695f6b8a5fd5712d6b0ed5260a50f77fb8684685d7e6e4d90c18c47d469",
      "type": "font",
      "file": "fonts/813.ttf",
      "catalogId": "813"
    },
    {
      "id": "font:814",
      "name": "Eurostile LT Std GEO_Mt Demi",
      "family": "Eurostile LT Std GEO_Mt",
      "style": "SemiBold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/814/Eurostile-LT-Std-GEO-Mt-Demi",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b067ad74ea2f28b02a128aba65d4932413d2b538e939452be1e4e3ce3ec3e1de",
      "type": "font",
      "file": "fonts/814.ttf",
      "catalogId": "814"
    },
    {
      "id": "font:815",
      "name": "Eurostile LT Std GEO_Mt Demi Italic",
      "family": "Eurostile LT Std GEO_Mt",
      "style": "SemiBold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/815/Eurostile-LT-Std-GEO-Mt-Demi-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c8892b38f9f6e94a5c099e7b9bd2735fec0c17d7f32f33a0064b839989f3fc3d",
      "type": "font",
      "file": "fonts/815.ttf",
      "catalogId": "815"
    },
    {
      "id": "font:812",
      "name": "Eurostile LT Std GEO_Mt Italic",
      "family": "Eurostile LT Std GEO_Mt",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/812/Eurostile-LT-Std-GEO-Mt-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4b85ca255d2663a931d580af37cb0929a2d1b8d8aaf8c0ab72b2df724a143fb7",
      "type": "font",
      "file": "fonts/812.ttf",
      "catalogId": "812"
    },
    {
      "id": "font:810",
      "name": "Eurostile LT Std GEO_Mt Regular",
      "family": "Eurostile LT Std GEO_Mt",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/810/Eurostile-LT-Std-GEO-Mt-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "36d139a0dee56ea3251f0d62ce477ad884e27b27c5683126c20f70cf81bb2b68",
      "type": "font",
      "file": "fonts/810.ttf",
      "catalogId": "810"
    },
    {
      "id": "font:805",
      "name": "Eurostile LT Std GEO_Nus Bold",
      "family": "Eurostile LT Std GEO_Nus",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/805/Eurostile-LT-Std-GEO-Nus-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2073a1a842a7bbe0e3023fb2eeb7c9a679e05e3d2fad32e820ebde365c1669ef",
      "type": "font",
      "file": "fonts/805.ttf",
      "catalogId": "805"
    },
    {
      "id": "font:807",
      "name": "Eurostile LT Std GEO_Nus Bold Italic",
      "family": "Eurostile LT Std GEO_Nus",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/807/Eurostile-LT-Std-GEO-Nus-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "103dfb7c46a065edb667c4e8710cf3fb9242c000a4b9c8212c045d1ac486eeb8",
      "type": "font",
      "file": "fonts/807.ttf",
      "catalogId": "807"
    },
    {
      "id": "font:808",
      "name": "Eurostile LT Std GEO_Nus Demi",
      "family": "Eurostile LT Std GEO_Nus",
      "style": "SemiBold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/808/Eurostile-LT-Std-GEO-Nus-Demi",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e5cbc511195b64e22581f04f6547648dc36d4e22a98169066e02efb934c965d3",
      "type": "font",
      "file": "fonts/808.ttf",
      "catalogId": "808"
    },
    {
      "id": "font:809",
      "name": "Eurostile LT Std GEO_Nus Demi Italic",
      "family": "Eurostile LT Std GEO_Nus",
      "style": "SemiBold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/809/Eurostile-LT-Std-GEO-Nus-Demi-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "be0b331567e6affd0694773f9c9133a7bf756dce302df1b55334bcadf1ce4b03",
      "type": "font",
      "file": "fonts/809.ttf",
      "catalogId": "809"
    },
    {
      "id": "font:806",
      "name": "Eurostile LT Std GEO_Nus Italic",
      "family": "Eurostile LT Std GEO_Nus",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/806/Eurostile-LT-Std-GEO-Nus-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "72e116996252f3c6a6af2a0bbd2ba16cf52b74fea37b6f037fab08a3cbbb04d7",
      "type": "font",
      "file": "fonts/806.ttf",
      "catalogId": "806"
    },
    {
      "id": "font:804",
      "name": "Eurostile LT Std GEO_Nus Regular",
      "family": "Eurostile LT Std GEO_Nus",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/804/Eurostile-LT-Std-GEO-Nus-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "769e4071f6013aa42f0b5eb5eb995199dd2e87fe69d607e845e8d6a923dede83",
      "type": "font",
      "file": "fonts/804.ttf",
      "catalogId": "804"
    },
    {
      "id": "font:219",
      "name": "G&G_Ilia Bold",
      "family": "G&G_Ilia",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/219/G%26G-Ilia-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f7a810f32f06df5452e1974a109713f6c5b6c6a79dbb54af2c759882889b15db",
      "type": "font",
      "file": "fonts/219.ttf",
      "catalogId": "219"
    },
    {
      "id": "font:218",
      "name": "G&G_Ilia Normal",
      "family": "G&G_Ilia",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/218/G%26G-Ilia-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "6d5f3bfa91b31616fd842a6c4c98d48af179171ddd435de97d1741481ecd0d6d",
      "type": "font",
      "file": "fonts/218.ttf",
      "catalogId": "218"
    },
    {
      "id": "font:220",
      "name": "G&G_IliaM",
      "family": "G&G_IliaM",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/220/G%26G-IliaM",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2f98b2b7eb61ac4824c966b8e83bbf9ae4c4651f7a002e8464ce3187589a0840",
      "type": "font",
      "file": "fonts/220.ttf",
      "catalogId": "220"
    },
    {
      "id": "font:221",
      "name": "G&G_IliaM Bold",
      "family": "G&G_IliaM",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/221/G%26G-IliaM-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "77965e123d683acd144d7dfe492d53e81fea057921c36708e820d331f24b1963",
      "type": "font",
      "file": "fonts/221.ttf",
      "catalogId": "221"
    },
    {
      "id": "font:223",
      "name": "G&G_IllliaM Bold",
      "family": "G&G_IllliaM",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/223/G%26G-IllliaM-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7b9ee16a8aec6df78425ef7129cb020b527dbec891cd17855c42dd6adf5dfcd5",
      "type": "font",
      "file": "fonts/223.ttf",
      "catalogId": "223"
    },
    {
      "id": "font:222",
      "name": "G&G_IllliaM Normal",
      "family": "G&G_IllliaM",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/222/G%26G-IllliaM-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "bb21c8f2d4ad9e8948671ebd767a06116e3012ad8ecc4ed178630cc3af2e43ac",
      "type": "font",
      "file": "fonts/222.ttf",
      "catalogId": "222"
    },
    {
      "id": "font:224",
      "name": "G&G_Kolhety",
      "family": "G&G_Kolhety",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/224/G%26G-Kolhety",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "82ae42626e87e7f8f7218d41fbae30336d4c6b07faab695e811e58a72d798f68",
      "type": "font",
      "file": "fonts/224.ttf",
      "catalogId": "224"
    },
    {
      "id": "font:225",
      "name": "G&G_Kolhety Bold",
      "family": "G&G_Kolhety",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/225/G%26G-Kolhety-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5d39794fa35c1980753fe6d2269175d8d0ae964ef5da1a9d39bd7a97ac88a8f2",
      "type": "font",
      "file": "fonts/225.ttf",
      "catalogId": "225"
    },
    {
      "id": "font:229",
      "name": "Geo AcadMtavr",
      "family": "Geo AcadMtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/229/Geo-AcadMtavr",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f0c33a710d20103de2a7b1c16b62e375e78b5dd2faa6e821d80da2ddc4f934cd",
      "type": "font",
      "file": "fonts/229.ttf",
      "catalogId": "229"
    },
    {
      "id": "font:230",
      "name": "Geo AcadMtavr Bold",
      "family": "Geo AcadMtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/230/Geo-AcadMtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "10fe4d118d7f425dc698f94e31adfcbce0a7d3ffa549c5c469ce3a8e03085cf7",
      "type": "font",
      "file": "fonts/230.ttf",
      "catalogId": "230"
    },
    {
      "id": "font:232",
      "name": "Geo AcadNusx Bold",
      "family": "Geo AcadNusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/232/Geo-AcadNusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8f6fdce3667cc727f4234a8678c801b185f76eedb9ed8720e057fda2332433e2",
      "type": "font",
      "file": "fonts/232.ttf",
      "catalogId": "232"
    },
    {
      "id": "font:231",
      "name": "Geo AcadNusx Normal",
      "family": "Geo AcadNusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/231/Geo-AcadNusx-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "369d631e1c749b378451207bf5fe093b9f08284ab4630ec6d0f03a438f0fe418",
      "type": "font",
      "file": "fonts/231.ttf",
      "catalogId": "231"
    },
    {
      "id": "font:250",
      "name": "Geo ChveuMtavr Bold",
      "family": "Geo ChveuMtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/250/Geo-ChveuMtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e7e5b0da7f2cfcfbbe8b4d0d03f1d1d3d99a4cd45a00cf063a2cc1212dee170f",
      "type": "font",
      "file": "fonts/250.ttf",
      "catalogId": "250"
    },
    {
      "id": "font:249",
      "name": "Geo ChveuMtavr Normal",
      "family": "Geo ChveuMtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/249/Geo-ChveuMtavr-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4dfaf6419d0ec45e90c3ec1251cab72829a70b438cacace363eb38457f012296",
      "type": "font",
      "file": "fonts/249.ttf",
      "catalogId": "249"
    },
    {
      "id": "font:252",
      "name": "Geo ChveuNusx Bold",
      "family": "Geo ChveuNusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/252/Geo-ChveuNusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2b0426947dd92762543e4a7b331659bea13cf1ba91d29cc47e296d1028fc3d8c",
      "type": "font",
      "file": "fonts/252.ttf",
      "catalogId": "252"
    },
    {
      "id": "font:251",
      "name": "Geo ChveuNusx Normal",
      "family": "Geo ChveuNusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/251/Geo-ChveuNusx-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "580f48d4e776302d4f8a46487f9b65c98dac2ac92bbc8cbc43740b7dff12e4d2",
      "type": "font",
      "file": "fonts/251.ttf",
      "catalogId": "251"
    },
    {
      "id": "font:259",
      "name": "Geo Dumbadze Mtavr Bold",
      "family": "Geo Dumbadze Mtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/259/Geo-Dumbadze-Mtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "117f457f5cba10d06b913f813449db0506370be8a670cac23398b8b09ada45fe",
      "type": "font",
      "file": "fonts/259.ttf",
      "catalogId": "259"
    },
    {
      "id": "font:260",
      "name": "Geo Dumbadze Mtavr Bold Italic",
      "family": "Geo Dumbadze Mtavr",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/260/Geo-Dumbadze-Mtavr-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "53f080d6cb22375b08cc9c1e3bb22d6fb2508a9a9ab15096ce55829ba2f9ac61",
      "type": "font",
      "file": "fonts/260.ttf",
      "catalogId": "260"
    },
    {
      "id": "font:261",
      "name": "Geo Dumbadze Mtavr Italic",
      "family": "Geo Dumbadze Mtavr",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/261/Geo-Dumbadze-Mtavr-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "285d2846194ab6e958ccd9b709d39552c7c0325175fb3564b37660ccdfc9086c",
      "type": "font",
      "file": "fonts/261.ttf",
      "catalogId": "261"
    },
    {
      "id": "font:263",
      "name": "Geo Dumbadze Nusx Bold",
      "family": "Geo Dumbadze Nusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/263/Geo-Dumbadze-Nusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a1eccb7fe5a7d40d4d3860a0796d3eb2a8dd7041c81ca2195ca9225bf1bd6372",
      "type": "font",
      "file": "fonts/263.ttf",
      "catalogId": "263"
    },
    {
      "id": "font:264",
      "name": "Geo Dumbadze Nusx Bold Italic",
      "family": "Geo Dumbadze Nusx",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/264/Geo-Dumbadze-Nusx-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c2112536b687798aa2114b8ae94a180aa01ddec78ded76c33e9e44d73f5afa4e",
      "type": "font",
      "file": "fonts/264.ttf",
      "catalogId": "264"
    },
    {
      "id": "font:265",
      "name": "Geo Dumbadze Nusx Italic",
      "family": "Geo Dumbadze Nusx",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/265/Geo-Dumbadze-Nusx-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0d1e5f8bbac05dec2218b8c0060d998536013766fce0000d8d1d041ddd9037c9",
      "type": "font",
      "file": "fonts/265.ttf",
      "catalogId": "265"
    },
    {
      "id": "font:277",
      "name": "Geo Grigolia Mtavr",
      "family": "Geo Grigolia Mtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/277/Geo-Grigolia-Mtavr",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d806caf82602e4e6c01f86fa5c1cee14405a680d3c522c94885a867b6908195d",
      "type": "font",
      "file": "fonts/277.ttf",
      "catalogId": "277"
    },
    {
      "id": "font:278",
      "name": "Geo Grigolia Mtavr Bold",
      "family": "Geo Grigolia Mtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/278/Geo-Grigolia-Mtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3b80797118010211e5f7678f70ea5166ad3fad2c6632c203b470dfcc8ac316bd",
      "type": "font",
      "file": "fonts/278.ttf",
      "catalogId": "278"
    },
    {
      "id": "font:279",
      "name": "Geo Grigolia Nusx",
      "family": "Geo Grigolia Nusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/279/Geo-Grigolia-Nusx",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a37b8af8befbfef2300029595f553d4e11466c83795819f65876d1750105fb0b",
      "type": "font",
      "file": "fonts/279.ttf",
      "catalogId": "279"
    },
    {
      "id": "font:280",
      "name": "Geo Grigolia Nusx Bold",
      "family": "Geo Grigolia Nusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/280/Geo-Grigolia-Nusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "df1d0be07e78970b4bdb92e2ddcb5e9cf604ee69f16dc65f04d19e372f8fbd6c",
      "type": "font",
      "file": "fonts/280.ttf",
      "catalogId": "280"
    },
    {
      "id": "font:281",
      "name": "Geo GrigoliaPolygraph",
      "family": "Geo GrigoliaPolygraph",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/281/Geo-GrigoliaPolygraph",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9079888b46391a65868662719e1c9fc868bc6dbbed75237efff9e60edf97e508",
      "type": "font",
      "file": "fonts/281.ttf",
      "catalogId": "281"
    },
    {
      "id": "font:282",
      "name": "Geo GrigoliaPolygraph Bold",
      "family": "Geo GrigoliaPolygraph",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/282/Geo-GrigoliaPolygraph-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "72a878849ec9640bbfd4500e69b1a0cd377fb615b1b90729477dbcd023c809bf",
      "type": "font",
      "file": "fonts/282.ttf",
      "catalogId": "282"
    },
    {
      "id": "font:285",
      "name": "Geo Ilia Mtavr Bold",
      "family": "Geo Ilia Mtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/285/Geo-Ilia-Mtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9366a91e8dd4a461cb6be9eeacccb9100dff1070c3dad8700b071100857d3934",
      "type": "font",
      "file": "fonts/285.ttf",
      "catalogId": "285"
    },
    {
      "id": "font:284",
      "name": "Geo Ilia Mtavr Normal",
      "family": "Geo Ilia Mtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/284/Geo-Ilia-Mtavr-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5596aa5e0d9a32daa58669d4418f0a35139ccfbe9e9cc5741dee7afb20163382",
      "type": "font",
      "file": "fonts/284.ttf",
      "catalogId": "284"
    },
    {
      "id": "font:287",
      "name": "Geo Ilia Nusx Bold",
      "family": "Geo Ilia Nusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/287/Geo-Ilia-Nusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ef92555b0738c57034a5bed167e471323ae213e099463f96a889b7dd0fb02d5f",
      "type": "font",
      "file": "fonts/287.ttf",
      "catalogId": "287"
    },
    {
      "id": "font:286",
      "name": "Geo Ilia Nusx Normal",
      "family": "Geo Ilia Nusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "G&G Georgian Font TaskForce Group"
      ],
      "source": "https://fonts.ge/en/font/286/Geo-Ilia-Nusx-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c3aabc44682174af60df45e1f5a5175205b17b7f0fe1faa2a62b7e8ddbe0bab1",
      "type": "font",
      "file": "fonts/286.ttf",
      "catalogId": "286"
    },
    {
      "id": "font:296",
      "name": "Geo Kolkheti Mtavr Bold",
      "family": "Geo Kolkheti Mtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/296/Geo-Kolkheti-Mtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "034020bb048df26b86fff772d85647413c85347b4d1cd90d32886dd72437a7ff",
      "type": "font",
      "file": "fonts/296.ttf",
      "catalogId": "296"
    },
    {
      "id": "font:295",
      "name": "Geo Kolkheti Mtavr Normal",
      "family": "Geo Kolkheti Mtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/295/Geo-Kolkheti-Mtavr-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4798b623f9dc618c19791c52195209889948af4e03f613da452a793dacb1a8d7",
      "type": "font",
      "file": "fonts/295.ttf",
      "catalogId": "295"
    },
    {
      "id": "font:297",
      "name": "Geo Kolkheti Nusx Bold",
      "family": "Geo Kolkheti Nusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/297/Geo-Kolkheti-Nusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "482401172b08c4e4f6efe41bfc97d6c49846316ff7007a542075a2a66dd01fd4",
      "type": "font",
      "file": "fonts/297.ttf",
      "catalogId": "297"
    },
    {
      "id": "font:298",
      "name": "Geo Kolkheti Nusx Normal",
      "family": "Geo Kolkheti Nusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/298/Geo-Kolkheti-Nusx-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b3f732ff838041e3f493f65ec5091337121aba6ed6b70d56b90e3fb2ea44eeb9",
      "type": "font",
      "file": "fonts/298.ttf",
      "catalogId": "298"
    },
    {
      "id": "font:388",
      "name": "Geo Literaturuly N",
      "family": "Geo Literaturuly N",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/388/Geo-Literaturuly-N",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c19e89b47e480312de223a734f0240e8e0bb170985cde51994a38249ec3ace41",
      "type": "font",
      "file": "fonts/388.ttf",
      "catalogId": "388"
    },
    {
      "id": "font:390",
      "name": "Geo Literaturuly N Bold",
      "family": "Geo Literaturuly N",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/390/Geo-Literaturuly-N-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "889d6f2a00f28173bfe42d77838d18be2654dd53e13f6fb4000384709be20938",
      "type": "font",
      "file": "fonts/390.ttf",
      "catalogId": "390"
    },
    {
      "id": "font:391",
      "name": "Geo Literaturuly N Bold Italic",
      "family": "Geo Literaturuly N",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/391/Geo-Literaturuly-N-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3bb09694c47b369d000331a4b44391a17f0fe7ac112d687684fce860b372aee6",
      "type": "font",
      "file": "fonts/391.ttf",
      "catalogId": "391"
    },
    {
      "id": "font:389",
      "name": "Geo Literaturuly N Italic",
      "family": "Geo Literaturuly N",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/389/Geo-Literaturuly-N-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3b54ff048890abbe6ef3a5b50fef744e55f699abb405c43bac458c4b569c2af7",
      "type": "font",
      "file": "fonts/389.ttf",
      "catalogId": "389"
    },
    {
      "id": "font:303",
      "name": "Geo LiterMtavr Bold",
      "family": "Geo LiterMtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/303/Geo-LiterMtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3b7ce3716c384bfb19be149b8b499a8d76385da3d97af339f28f8f527304b8e0",
      "type": "font",
      "file": "fonts/303.ttf",
      "catalogId": "303"
    },
    {
      "id": "font:302",
      "name": "Geo LiterMtavr Normal",
      "family": "Geo LiterMtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/302/Geo-LiterMtavr-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "caf5aa820ac76bc17c504404e3d2342b61ce8549a557091d02945200772835de",
      "type": "font",
      "file": "fonts/302.ttf",
      "catalogId": "302"
    },
    {
      "id": "font:305",
      "name": "Geo LiterNusx Bold",
      "family": "Geo LiterNusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/305/Geo-LiterNusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b048a9488bf6f325f3dbdd808dabae873b319fcf6b81f7e94ee7c9359a52af51",
      "type": "font",
      "file": "fonts/305.ttf",
      "catalogId": "305"
    },
    {
      "id": "font:304",
      "name": "Geo LiterNusx Normal",
      "family": "Geo LiterNusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/304/Geo-LiterNusx-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a3fa486b5386acef158e2d9f5a56579e3c9c47c594fc815f2ea8d1df636bce2e",
      "type": "font",
      "file": "fonts/304.ttf",
      "catalogId": "304"
    },
    {
      "id": "font:316",
      "name": "Geo Mrude Normal",
      "family": "",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/316/Geo-Mrude-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0c0162cd7c191003aeb107adf84db8c790fe68e38ed1b28b65ef89218a6585d1",
      "type": "font",
      "file": "fonts/316.ttf",
      "catalogId": "316"
    },
    {
      "id": "font:16",
      "name": "LitNusx",
      "family": "",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/16/LitNusx",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "119d2415b374dcdd9686d4ba370efdab04828f1f4332379e07babb7ce178516c",
      "type": "font",
      "file": "fonts/16.ttf",
      "catalogId": "16"
    },
    {
      "id": "font:408",
      "name": "GeoDumba Bold",
      "family": "GeoDumba",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/408/GeoDumba-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "bc86565ca5542e0b498dca68709c19f5ac544654aa7bfeeafe8b5d93cfd1e42f",
      "type": "font",
      "file": "fonts/408.ttf",
      "catalogId": "408"
    },
    {
      "id": "font:410",
      "name": "GeoDumba Bold Italic",
      "family": "GeoDumba",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/410/GeoDumba-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a6fde17d8bcee0d6ae9b9012d80a5bcaa02709d5dd8c0db9415d61628a78d497",
      "type": "font",
      "file": "fonts/410.ttf",
      "catalogId": "410"
    },
    {
      "id": "font:409",
      "name": "GeoDumba Italic",
      "family": "GeoDumba",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/409/GeoDumba-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "cbcb15eefb891192098d33044628b55c0e6319c40d1b5a80e92f5b2cbd17f956",
      "type": "font",
      "file": "fonts/409.ttf",
      "catalogId": "409"
    },
    {
      "id": "font:413",
      "name": "GeoEDumba Bold",
      "family": "GeoEDumba",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/413/GeoEDumba-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c444ea9ef1d09aa97e525b0714975d7a9ee8d84ca3ab949789a627908930e8d1",
      "type": "font",
      "file": "fonts/413.ttf",
      "catalogId": "413"
    },
    {
      "id": "font:415",
      "name": "GeoEDumba Bold Italic",
      "family": "GeoEDumba",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/415/GeoEDumba-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2064e6289f4c11cad49077973db57d89c555434e8cca3c50a63555896e092d14",
      "type": "font",
      "file": "fonts/415.ttf",
      "catalogId": "415"
    },
    {
      "id": "font:414",
      "name": "GeoEDumba Italic",
      "family": "GeoEDumba",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Atech Software"
      ],
      "source": "https://fonts.ge/en/font/414/GeoEDumba-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "31a37079b2f822215e908e43ee42c672355197be360c0360c64ac8e73ae2557e",
      "type": "font",
      "file": "fonts/414.ttf",
      "catalogId": "414"
    },
    {
      "id": "font:421",
      "name": "Georgian Times Bold",
      "family": "Georgian Times",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/421/Georgian-Times-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0111b454aad5fd8e9d85988061b4cf13ab398792ebe8f990348fd48d53c3932f",
      "type": "font",
      "file": "fonts/421.ttf",
      "catalogId": "421"
    },
    {
      "id": "font:420",
      "name": "Georgian Times Normal",
      "family": "Georgian Times",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/420/Georgian-Times-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a14c49121252ce2b0a2f31e86afb4df6652c502b35c760fa7e9e1a3ad58c06be",
      "type": "font",
      "file": "fonts/420.ttf",
      "catalogId": "420"
    },
    {
      "id": "font:363",
      "name": "Geo_Academiuri",
      "family": "Geo_Academiuri",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/363/Geo-Academiuri",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "06cff9a1858f5d2fc1713b240bbb0b12ffd54f23a6cf77b6f894ad0b83c98028",
      "type": "font",
      "file": "fonts/363.ttf",
      "catalogId": "363"
    },
    {
      "id": "font:364",
      "name": "Geo_Academiuri Italic",
      "family": "Geo_Academiuri",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/364/Geo-Academiuri-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "eb8d85498cde7d6e5b46eddedf0dced4f7c13e19be706b900ba1976aad0d8c29",
      "type": "font",
      "file": "fonts/364.ttf",
      "catalogId": "364"
    },
    {
      "id": "font:366",
      "name": "Geo_Arial",
      "family": "Geo_Arial",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/366/Geo-Arial",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c4af1f1d34871513f6ef84d361893dfe01163a6b236a7e85e3659ee00d45f6a0",
      "type": "font",
      "file": "fonts/366.ttf",
      "catalogId": "366"
    },
    {
      "id": "font:367",
      "name": "Geo_Arial Bold",
      "family": "Geo_Arial",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/367/Geo-Arial-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "297964b28b4aa17a08efc805c4ff7f2870756227a897e875e690b420ffd528a6",
      "type": "font",
      "file": "fonts/367.ttf",
      "catalogId": "367"
    },
    {
      "id": "font:369",
      "name": "Geo_Arial Bold Italic",
      "family": "Geo_Arial",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/369/Geo-Arial-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2f6d329bf12eafebd63b32c9d93e8bb470f09ca50c8e7b4079cee3eed25c4176",
      "type": "font",
      "file": "fonts/369.ttf",
      "catalogId": "369"
    },
    {
      "id": "font:368",
      "name": "Geo_Arial Italic",
      "family": "Geo_Arial",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/368/Geo-Arial-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "24afa94ec4d1c6919b9d5ad70a33dd7c015533a30c5af9680ee1dde0da676c65",
      "type": "font",
      "file": "fonts/368.ttf",
      "catalogId": "368"
    },
    {
      "id": "font:370",
      "name": "Geo_Courier",
      "family": "Geo_Courier",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/370/Geo-Courier",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0a7499c0abaec3a308e4b43fa90fcca466ec6b0f1b8af61d530c2664708bd8c9",
      "type": "font",
      "file": "fonts/370.ttf",
      "catalogId": "370"
    },
    {
      "id": "font:371",
      "name": "Geo_Courier Bold",
      "family": "Geo_Courier",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/371/Geo-Courier-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "aea702ff7c9a3adbc5e6759339c0e4a71d4d61336e38efee35f79f9f9025117b",
      "type": "font",
      "file": "fonts/371.ttf",
      "catalogId": "371"
    },
    {
      "id": "font:373",
      "name": "Geo_Courier Bold Italic",
      "family": "Geo_Courier",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/373/Geo-Courier-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9454fd10de14ff1d9dcd37f2c06466e2c47a6b1ea1b1d75deaf31d17514ad4e3",
      "type": "font",
      "file": "fonts/373.ttf",
      "catalogId": "373"
    },
    {
      "id": "font:372",
      "name": "Geo_Courier Italic",
      "family": "Geo_Courier",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/372/Geo-Courier-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "40b5cab3691d0ab2a149e59849b4a855d7f7b74e4a834f558efbc575a80f906b",
      "type": "font",
      "file": "fonts/372.ttf",
      "catalogId": "372"
    },
    {
      "id": "font:374",
      "name": "Geo_Dumbadze",
      "family": "Geo_Dumbadze",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/374/Geo-Dumbadze",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "411863f79dfed5ef693e7fe08d5aca400b98bfd8899e265b4d3ebda3ecb1314f",
      "type": "font",
      "file": "fonts/374.ttf",
      "catalogId": "374"
    },
    {
      "id": "font:375",
      "name": "Geo_Dumbadze Italic",
      "family": "Geo_Dumbadze",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/375/Geo-Dumbadze-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f89bd7c7d44444c8259ed48a7dc2ffab3bfcc9d7a249fb2fdabad75795f32299",
      "type": "font",
      "file": "fonts/375.ttf",
      "catalogId": "375"
    },
    {
      "id": "font:379",
      "name": "Geo_Kolkheti",
      "family": "Geo_Kolkheti",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/379/Geo-Kolkheti",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3f3ff6531f1c79b03c3e9532caf49112a3cebe547661e1d90073d582702fcbfe",
      "type": "font",
      "file": "fonts/379.ttf",
      "catalogId": "379"
    },
    {
      "id": "font:380",
      "name": "Geo_Kolkheti Bold",
      "family": "Geo_Kolkheti",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/380/Geo-Kolkheti-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ead8eaa84daecc132f34a8f37c46661a535e628574d39a67cd052fe1021bd856",
      "type": "font",
      "file": "fonts/380.ttf",
      "catalogId": "380"
    },
    {
      "id": "font:382",
      "name": "Geo_Kolkheti Bold Italic",
      "family": "Geo_Kolkheti",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/382/Geo-Kolkheti-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9029e455dd4001a2a42696b6e6e972fe465b1f586928a250b058d91c045c7ae0",
      "type": "font",
      "file": "fonts/382.ttf",
      "catalogId": "382"
    },
    {
      "id": "font:381",
      "name": "Geo_Kolkheti Italic",
      "family": "Geo_Kolkheti",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/381/Geo-Kolkheti-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "52c7e8c48834e7527c6485300b632e94a6c6e0dc13664fa9bbdb581970f13561",
      "type": "font",
      "file": "fonts/381.ttf",
      "catalogId": "381"
    },
    {
      "id": "font:384",
      "name": "Geo_Literaturuli",
      "family": "Geo_Literaturuli",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/384/Geo-Literaturuli",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a932d932ea800546b798bed5b6989d524e8f87d73268ad4607078865640719f2",
      "type": "font",
      "file": "fonts/384.ttf",
      "catalogId": "384"
    },
    {
      "id": "font:385",
      "name": "Geo_Literaturuli Bold",
      "family": "Geo_Literaturuli",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/385/Geo-Literaturuli-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f8b45baa229daa067695b4ea62cf85a753e791d6a879515cd7250cc249df82f3",
      "type": "font",
      "file": "fonts/385.ttf",
      "catalogId": "385"
    },
    {
      "id": "font:387",
      "name": "Geo_Literaturuli Bold Italic",
      "family": "Geo_Literaturuli",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/387/Geo-Literaturuli-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "771e9c9fcc71a20fd3705ea79b0a7320c19e8c1cb8f3238dae4a3b2940389edd",
      "type": "font",
      "file": "fonts/387.ttf",
      "catalogId": "387"
    },
    {
      "id": "font:386",
      "name": "Geo_Literaturuli Italic",
      "family": "Geo_Literaturuli",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/386/Geo-Literaturuli-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "641aa455d8897aea833e682fd02886fb93dc9aeac34e2624615b00a67b50965f",
      "type": "font",
      "file": "fonts/386.ttf",
      "catalogId": "386"
    },
    {
      "id": "font:5",
      "name": "Geo_Times",
      "family": "Geo_Times",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/5/Geo-Times",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e4e970e182834f00310c11548034db170c0dee18741a9d2831f1f733c1544557",
      "type": "font",
      "file": "fonts/5.ttf",
      "catalogId": "5"
    },
    {
      "id": "font:10",
      "name": "Geo_Times Bold",
      "family": "Geo_Times",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/10/Geo-Times-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2e21f5d875331cebd4e5f5ed4dc80eb9c4197702ad7e7818af0c451bcfc29a4f",
      "type": "font",
      "file": "fonts/10.ttf",
      "catalogId": "10"
    },
    {
      "id": "font:12",
      "name": "Geo_Times Bold Italic",
      "family": "Geo_Times",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/12/Geo-Times-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2a3046e78278da2e808871c992673b3e2256bc8792523f4becc4e62c0f35f8b0",
      "type": "font",
      "file": "fonts/12.ttf",
      "catalogId": "12"
    },
    {
      "id": "font:11",
      "name": "Geo_Times Italic",
      "family": "Geo_Times",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/11/Geo-Times-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "911e7c28f78ff6761d955591f0e53afa6cb36cd199e6c48c21fc29d0782198b5",
      "type": "font",
      "file": "fonts/11.ttf",
      "catalogId": "11"
    },
    {
      "id": "font:394",
      "name": "Geo_Venuri",
      "family": "Geo_Venuri",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/394/Geo-Venuri",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7807f9f68b412f5cf212e438b7ed476a338a83f6de5509448c794fadc19a565d",
      "type": "font",
      "file": "fonts/394.ttf",
      "catalogId": "394"
    },
    {
      "id": "font:395",
      "name": "Geo_Venuri Bold",
      "family": "Geo_Venuri",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/395/Geo-Venuri-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "af2e33294157d6cafca43acdacfef4587fa819817dee31904a62de612a43e97a",
      "type": "font",
      "file": "fonts/395.ttf",
      "catalogId": "395"
    },
    {
      "id": "font:397",
      "name": "Geo_Venuri Bold Italic",
      "family": "Geo_Venuri",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/397/Geo-Venuri-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d2981939de48d10dc7bdc90cbe5755fb2675216419276d995f20e93d2107617c",
      "type": "font",
      "file": "fonts/397.ttf",
      "catalogId": "397"
    },
    {
      "id": "font:396",
      "name": "Geo_Venuri Italic",
      "family": "Geo_Venuri",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/396/Geo-Venuri-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "499bc7615995bc7f15106c6bd39bcdae222f4a21a165e2aa3b1ef2758f3d6306",
      "type": "font",
      "file": "fonts/396.ttf",
      "catalogId": "396"
    },
    {
      "id": "font:398",
      "name": "Geo_WWW_Courier",
      "family": "Geo_WWW_Courier",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/398/Geo-WWW-Courier",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8ad8f0662072708d955277ecf69195fe7d980a0c97173edb8a93cd426a729307",
      "type": "font",
      "file": "fonts/398.ttf",
      "catalogId": "398"
    },
    {
      "id": "font:399",
      "name": "Geo_WWW_Courier Bold",
      "family": "Geo_WWW_Courier",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/399/Geo-WWW-Courier-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "18376995cfd79e1a8fd819ada0e9a0ff40f152d5bc98625a7b06344bbd3de11e",
      "type": "font",
      "file": "fonts/399.ttf",
      "catalogId": "399"
    },
    {
      "id": "font:401",
      "name": "Geo_WWW_Courier Bold Italic",
      "family": "Geo_WWW_Courier",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/401/Geo-WWW-Courier-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e0eb292efd122287ae0e87ba8a07f22a6652f09db938a49ef0d5835603d4827c",
      "type": "font",
      "file": "fonts/401.ttf",
      "catalogId": "401"
    },
    {
      "id": "font:400",
      "name": "Geo_WWW_Courier Italic",
      "family": "Geo_WWW_Courier",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze",
        "George Bagrationi",
        "Anton Dumbadze"
      ],
      "source": "https://fonts.ge/en/font/400/Geo-WWW-Courier-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d0ff582e175f0703d470a5c296c762f0163348fe05f8a8d90989bfd3916722d9",
      "type": "font",
      "file": "fonts/400.ttf",
      "catalogId": "400"
    },
    {
      "id": "font:402",
      "name": "Geo_WWW_Times",
      "family": "Geo_WWW_Times",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/402/Geo-WWW-Times",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8a7ce8235f0b34945cc99623d3b59ae2b118a89a7728b19b228442065f211624",
      "type": "font",
      "file": "fonts/402.ttf",
      "catalogId": "402"
    },
    {
      "id": "font:403",
      "name": "Geo_WWW_Times Bold",
      "family": "Geo_WWW_Times",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/403/Geo-WWW-Times-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d299c6237a0b0bc83d587f671cfcb9e4b2b8949d0961d5cdc1a6604951a75fff",
      "type": "font",
      "file": "fonts/403.ttf",
      "catalogId": "403"
    },
    {
      "id": "font:405",
      "name": "Geo_WWW_Times Bold Italic",
      "family": "Geo_WWW_Times",
      "style": "Bold Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/405/Geo-WWW-Times-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5da713ae67374b4b044ef5174acbacefca6a39379f2c592f66bf6fc6775fb890",
      "type": "font",
      "file": "fonts/405.ttf",
      "catalogId": "405"
    },
    {
      "id": "font:404",
      "name": "Geo_WWW_Times Italic",
      "family": "Geo_WWW_Times",
      "style": "Italic",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Gia Shervashidze"
      ],
      "source": "https://fonts.ge/en/font/404/Geo-WWW-Times-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "dc68aa5614b066d0bac7f2f443437742d74b791efe5827705e7468ca5c4e4418",
      "type": "font",
      "file": "fonts/404.ttf",
      "catalogId": "404"
    },
    {
      "id": "font:758",
      "name": "GF Aisi Mt Bold",
      "family": "GF Aisi Mt",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/758/GF-Aisi-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e999794c8c8c16a01456d3301339f3155d06e6d428bae143462375b8fb1338c8",
      "type": "font",
      "file": "fonts/758.otf",
      "catalogId": "758"
    },
    {
      "id": "font:760",
      "name": "GF Aisi Mt Bold Italic",
      "family": "GF Aisi Mt",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/760/GF-Aisi-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5b2078f88428097d782d28cce775c14914270c5ef52bbc5a028d0c48ec2370a8",
      "type": "font",
      "file": "fonts/760.otf",
      "catalogId": "760"
    },
    {
      "id": "font:759",
      "name": "GF Aisi Mt Italic",
      "family": "GF Aisi Mt",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/759/GF-Aisi-Mt-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "214cfd8cd356ae181ebf24adb0c393c12e547abf1dc852f00754aeb7a82fdc07",
      "type": "font",
      "file": "fonts/759.otf",
      "catalogId": "759"
    },
    {
      "id": "font:757",
      "name": "GF Aisi Mt Regular",
      "family": "GF Aisi Mt",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/757/GF-Aisi-Mt-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "fe3f84396ff767a206a5fd87627c1fa3f1f6b6f393063adef09ccb5f88758c60",
      "type": "font",
      "file": "fonts/757.otf",
      "catalogId": "757"
    },
    {
      "id": "font:763",
      "name": "GF Aisi Mt Light Light",
      "family": "GF Aisi Mt Light",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/763/GF-Aisi-Mt-Light-Light",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9796e7758d63edd30e184e5c76740bd32718689e1f32c1b817a1fde73252bf6f",
      "type": "font",
      "file": "fonts/763.otf",
      "catalogId": "763"
    },
    {
      "id": "font:764",
      "name": "GF Aisi Mt Light Light Italic",
      "family": "GF Aisi Mt Light",
      "style": "Light Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/764/GF-Aisi-Mt-Light-Light-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ccd01481612b17a3b792c78e5a564d3a8433cf073c93833091df7d936f71997d",
      "type": "font",
      "file": "fonts/764.otf",
      "catalogId": "764"
    },
    {
      "id": "font:761",
      "name": "GF Aisi Mt Medium Medium",
      "family": "GF Aisi Mt Medium",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/761/GF-Aisi-Mt-Medium-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "564ed45491f04c07ce6c24400991419227a83f945ea42586f760e04d91530327",
      "type": "font",
      "file": "fonts/761.otf",
      "catalogId": "761"
    },
    {
      "id": "font:762",
      "name": "GF Aisi Mt Medium Medium Italic",
      "family": "GF Aisi Mt Medium",
      "style": "Medium Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/762/GF-Aisi-Mt-Medium-Medium-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "fb152d5e30f92459c44a1654e34b8dc78d59abb7ecaa5f44052cc050deefb34b",
      "type": "font",
      "file": "fonts/762.otf",
      "catalogId": "762"
    },
    {
      "id": "font:766",
      "name": "GF Aisi Nus Bold",
      "family": "GF Aisi Nus",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/766/GF-Aisi-Nus-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a22a55b7257358fa91ae0e4836516efeb30c94a943fcff2fae9edddf733d5521",
      "type": "font",
      "file": "fonts/766.otf",
      "catalogId": "766"
    },
    {
      "id": "font:768",
      "name": "GF Aisi Nus Bold Italic",
      "family": "GF Aisi Nus",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/768/GF-Aisi-Nus-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9dd56fb50e310721f3de4655ff272a4f1bee5850e4c355d346d9bef69957562e",
      "type": "font",
      "file": "fonts/768.otf",
      "catalogId": "768"
    },
    {
      "id": "font:767",
      "name": "GF Aisi Nus Italic",
      "family": "GF Aisi Nus",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/767/GF-Aisi-Nus-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5c51ff997f360fdf3b1ff75a65a20d2ba075459736e49f819133fbe2c058cb81",
      "type": "font",
      "file": "fonts/767.otf",
      "catalogId": "767"
    },
    {
      "id": "font:765",
      "name": "GF Aisi Nus Regular",
      "family": "GF Aisi Nus",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/765/GF-Aisi-Nus-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "dff713845fecce51605c953287904584748ea979b831cdea9a4a09d0c4e25e7a",
      "type": "font",
      "file": "fonts/765.otf",
      "catalogId": "765"
    },
    {
      "id": "font:771",
      "name": "GF Aisi Nus Light Light",
      "family": "GF Aisi Nus Light",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/771/GF-Aisi-Nus-Light-Light",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "25fab080add99603bcd2a763833a016be5d69d13cde734cf071a70938acfb9f3",
      "type": "font",
      "file": "fonts/771.otf",
      "catalogId": "771"
    },
    {
      "id": "font:772",
      "name": "GF Aisi Nus Light Light Italic",
      "family": "GF Aisi Nus Light",
      "style": "Light Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/772/GF-Aisi-Nus-Light-Light-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "85c9eb00d1f01ef8b5f7ef134a6436c2382a9c27892d77b9a41361d07868aa7f",
      "type": "font",
      "file": "fonts/772.otf",
      "catalogId": "772"
    },
    {
      "id": "font:769",
      "name": "GF Aisi Nus Medium Medium",
      "family": "GF Aisi Nus Medium",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/769/GF-Aisi-Nus-Medium-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d9975efd4f1b1aeed856722b047df16b88ab8e39ccfbd1eaca6eea07fd67cc55",
      "type": "font",
      "file": "fonts/769.otf",
      "catalogId": "769"
    },
    {
      "id": "font:770",
      "name": "GF Aisi Nus Medium Medium Italic",
      "family": "GF Aisi Nus Medium",
      "style": "Medium Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/770/GF-Aisi-Nus-Medium-Medium-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "679003eabff7e7cb1cafa60b104efd89dd4c603ce424d783a671aa0a86692487",
      "type": "font",
      "file": "fonts/770.otf",
      "catalogId": "770"
    },
    {
      "id": "font:830",
      "name": "GF Alaverdi Mt Black",
      "family": "GF Alaverdi Mt",
      "style": "Black",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/830/GF-Alaverdi-Mt-Black",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "1c989454d63ad2b7fbbd8ed454b80d48d737472bbc84de70ff98db367e10caf4",
      "type": "font",
      "file": "fonts/830.ttf",
      "catalogId": "830"
    },
    {
      "id": "font:831",
      "name": "GF Alaverdi Mt Black Italic",
      "family": "GF Alaverdi Mt",
      "style": "Black Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/831/GF-Alaverdi-Mt-Black-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4c23fa4ae1d5cc49a319822d276921f28a0ecd9bcddc9abc5dbce05524e5091a",
      "type": "font",
      "file": "fonts/831.ttf",
      "catalogId": "831"
    },
    {
      "id": "font:825",
      "name": "GF Alaverdi Mt Bold",
      "family": "GF Alaverdi Mt",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/825/GF-Alaverdi-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "cba3433081ad3588f9044373a2253001c84024a8f273efea640e635ea629755b",
      "type": "font",
      "file": "fonts/825.ttf",
      "catalogId": "825"
    },
    {
      "id": "font:827",
      "name": "GF Alaverdi Mt Bold Italic",
      "family": "GF Alaverdi Mt",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/827/GF-Alaverdi-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4bf230831f4685d3f28cc7ddd87446d35878ae09bc2a401ad68c0b7d90b07070",
      "type": "font",
      "file": "fonts/827.ttf",
      "catalogId": "827"
    },
    {
      "id": "font:826",
      "name": "GF Alaverdi Mt Italic",
      "family": "GF Alaverdi Mt",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/826/GF-Alaverdi-Mt-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d9f48c19efe62a51aa1cd5acb40658cefd4252ac359c660b5c9b3887b87fab31",
      "type": "font",
      "file": "fonts/826.ttf",
      "catalogId": "826"
    },
    {
      "id": "font:828",
      "name": "GF Alaverdi Mt Light",
      "family": "GF Alaverdi Mt",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/828/GF-Alaverdi-Mt-Light",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "488df3829522b522445b5d8660460a518aa22d9be4800daae59d69e89ce446be",
      "type": "font",
      "file": "fonts/828.ttf",
      "catalogId": "828"
    },
    {
      "id": "font:829",
      "name": "GF Alaverdi Mt Light Italic",
      "family": "GF Alaverdi Mt",
      "style": "Light Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/829/GF-Alaverdi-Mt-Light-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2394970422dc463a4235e34c10f1527f260fb50ec49f18485be50a4113e056bb",
      "type": "font",
      "file": "fonts/829.ttf",
      "catalogId": "829"
    },
    {
      "id": "font:824",
      "name": "GF Alaverdi Mt Regular",
      "family": "GF Alaverdi Mt",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/824/GF-Alaverdi-Mt-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "be708026ce008197507cb5e2b60fc34e69d0d2f30b1b89cc55f3a8447370781a",
      "type": "font",
      "file": "fonts/824.ttf",
      "catalogId": "824"
    },
    {
      "id": "font:822",
      "name": "GF Alaverdi Nus Black",
      "family": "GF Alaverdi Nus",
      "style": "Black",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/822/GF-Alaverdi-Nus-Black",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "280259e96302af67977e034f70392aff5e7cf92cbe9a86b55aa5ee073125c5c0",
      "type": "font",
      "file": "fonts/822.ttf",
      "catalogId": "822"
    },
    {
      "id": "font:823",
      "name": "GF Alaverdi Nus Black Italic",
      "family": "GF Alaverdi Nus",
      "style": "Black Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/823/GF-Alaverdi-Nus-Black-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "03c09e86514cc43fb3e5effd547c42b5ba53c4f2ef33355c6fdafde083b16a1e",
      "type": "font",
      "file": "fonts/823.ttf",
      "catalogId": "823"
    },
    {
      "id": "font:817",
      "name": "GF Alaverdi Nus Bold",
      "family": "GF Alaverdi Nus",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/817/GF-Alaverdi-Nus-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "87a609f5795ba186297da86f84e81d6e5d9a20ea4edc65cb1f7fb77c58842c48",
      "type": "font",
      "file": "fonts/817.ttf",
      "catalogId": "817"
    },
    {
      "id": "font:819",
      "name": "GF Alaverdi Nus Bold Italic",
      "family": "GF Alaverdi Nus",
      "style": "Bold Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/819/GF-Alaverdi-Nus-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0cfdf00157a71e22448d15351709bc5e0f6ceccc16a3fa65317756942584bc76",
      "type": "font",
      "file": "fonts/819.ttf",
      "catalogId": "819"
    },
    {
      "id": "font:818",
      "name": "GF Alaverdi Nus Italic",
      "family": "GF Alaverdi Nus",
      "style": "Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/818/GF-Alaverdi-Nus-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "1637977f39fd01f5a73fcc09d1f514a38e877cd3662f6cdce94d5590cd375d61",
      "type": "font",
      "file": "fonts/818.ttf",
      "catalogId": "818"
    },
    {
      "id": "font:820",
      "name": "GF Alaverdi Nus Light",
      "family": "GF Alaverdi Nus",
      "style": "Light",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/820/GF-Alaverdi-Nus-Light",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ff0a1cc89453ac1d4f36d91c2d234a5e4b652d3c8ee18d359abe1785b2a11b7d",
      "type": "font",
      "file": "fonts/820.ttf",
      "catalogId": "820"
    },
    {
      "id": "font:821",
      "name": "GF Alaverdi Nus Light Italic",
      "family": "GF Alaverdi Nus",
      "style": "Light Italic",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/821/GF-Alaverdi-Nus-Light-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "efaf93a0895bd7dd643b75270dd07c6c5b0f5c5ea6e521c3e62573af0ecedf31",
      "type": "font",
      "file": "fonts/821.ttf",
      "catalogId": "821"
    },
    {
      "id": "font:816",
      "name": "GF Alaverdi Nus Regular",
      "family": "GF Alaverdi Nus",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/816/GF-Alaverdi-Nus-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "481806221043262a051de452197a27de626724ed71fb643d546afb118a553706",
      "type": "font",
      "file": "fonts/816.ttf",
      "catalogId": "816"
    },
    {
      "id": "font:432",
      "name": "GF Satellite 17 Mt Bold",
      "family": "GF Satellite 17 Mt",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/432/GF-Satellite-17-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "1bb80e768094b71fa3b4e59f901cae0e3586da428550f6158ceeb18c4e4abfb1",
      "type": "font",
      "file": "fonts/432.ttf",
      "catalogId": "432"
    },
    {
      "id": "font:433",
      "name": "GF Satellite 17 Mt Bold Italic",
      "family": "GF Satellite 17 Mt",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/433/GF-Satellite-17-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5c4ee8cb3cbdc589a14033afaa80311f56a9e4e398f4b089b11ddd599ab08faa",
      "type": "font",
      "file": "fonts/433.ttf",
      "catalogId": "433"
    },
    {
      "id": "font:423",
      "name": "GF Satellite 2 Mt",
      "family": "GF Satellite 2 Mt",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/423/GF-Satellite-2-Mt",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0050d79926636fb4fe10213b8ed72c613139db88eac4f0411896974909b8e676",
      "type": "font",
      "file": "fonts/423.ttf",
      "catalogId": "423"
    },
    {
      "id": "font:424",
      "name": "GF Satellite 2 Mt Bold",
      "family": "GF Satellite 2 Mt",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/424/GF-Satellite-2-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "fa57f6628df5b5d09de785c2ccb30ccd7332ca580ea2391e03714f7d4097eadc",
      "type": "font",
      "file": "fonts/424.ttf",
      "catalogId": "424"
    },
    {
      "id": "font:426",
      "name": "GF Satellite 2 Mt Bold Italic",
      "family": "GF Satellite 2 Mt",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/426/GF-Satellite-2-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "dd391c1227b23bd30c9e5fb46082dcb5c074077c85ea8486f8297a20f716a360",
      "type": "font",
      "file": "fonts/426.ttf",
      "catalogId": "426"
    },
    {
      "id": "font:425",
      "name": "GF Satellite 2 Mt Italic",
      "family": "GF Satellite 2 Mt",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/425/GF-Satellite-2-Mt-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7722e70aec1428021e50ce5355b1edb164448b00efe3592430c8efe47cb6ba81",
      "type": "font",
      "file": "fonts/425.ttf",
      "catalogId": "425"
    },
    {
      "id": "font:434",
      "name": "GF Satellite 28 Mt",
      "family": "GF Satellite 28 Mt",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/434/GF-Satellite-28-Mt",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "53f8ad31acae8bb4610db5664418b64f35fd0ea78ca137846b7438601aef6241",
      "type": "font",
      "file": "fonts/434.ttf",
      "catalogId": "434"
    },
    {
      "id": "font:435",
      "name": "GF Satellite 28 Mt Italic",
      "family": "GF Satellite 28 Mt",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/435/GF-Satellite-28-Mt-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "992f2ceb63cb147cc4fc34f3e48b1b63228619e1b832212749770380cfdc4a2d",
      "type": "font",
      "file": "fonts/435.ttf",
      "catalogId": "435"
    },
    {
      "id": "font:427",
      "name": "GF Satellite 3 Mt Bold",
      "family": "GF Satellite 3 Mt",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/427/GF-Satellite-3-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "607c0b6088796a2e37089830b6a33ff765391134446e5de4f9c9420c8add84cf",
      "type": "font",
      "file": "fonts/427.ttf",
      "catalogId": "427"
    },
    {
      "id": "font:428",
      "name": "GF Satellite 3 Mt Bold Italic",
      "family": "GF Satellite 3 Mt",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/428/GF-Satellite-3-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e6c7360e73bdcdab496cd56c19bdc82bb755088bd22e2949539b68e956628c1c",
      "type": "font",
      "file": "fonts/428.ttf",
      "catalogId": "428"
    },
    {
      "id": "font:429",
      "name": "GF Satellite 6 Mt",
      "family": "GF Satellite 6 Mt",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/429/GF-Satellite-6-Mt",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "839366a7011beefe07752e22152fd28d273ee1559ed0c4ca37ada6207456bfd8",
      "type": "font",
      "file": "fonts/429.ttf",
      "catalogId": "429"
    },
    {
      "id": "font:430",
      "name": "GF Satellite 6 Mt Bold",
      "family": "GF Satellite 6 Mt",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/430/GF-Satellite-6-Mt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3ddb09fbd1fa68db10b27c2ec08dfafd76b2d7582050cafc435fce75d07c108b",
      "type": "font",
      "file": "fonts/430.ttf",
      "catalogId": "430"
    },
    {
      "id": "font:431",
      "name": "GF Satellite 6 Mt Bold Italic",
      "family": "GF Satellite 6 Mt",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Merab Getsadze"
      ],
      "source": "https://fonts.ge/en/font/431/GF-Satellite-6-Mt-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e739f66c125463a541abd23cfa5acd5e7e92fa24d3eed130db80d8463245d48e",
      "type": "font",
      "file": "fonts/431.ttf",
      "catalogId": "431"
    },
    {
      "id": "font:861",
      "name": "GL Lortkipanidze Bold",
      "family": "GL Lortkipanidze",
      "style": "Bold",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "GeoLab",
        "Kirile Lortkipanidze",
        "Sofiko Gogoladze"
      ],
      "source": "https://fonts.ge/en/font/861/GL-Lortkipanidze-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f52d1e9bb2d02c120400b428eda3cc1c80e545c024bfebc5847d0070095a9272",
      "type": "font",
      "file": "fonts/861.ttf",
      "catalogId": "861"
    },
    {
      "id": "font:860",
      "name": "GL Lortkipanidze Regular",
      "family": "GL Lortkipanidze",
      "style": "Regular",
      "encoding": "Unicode (UTF-8)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "GeoLab",
        "Kirile Lortkipanidze",
        "Sofiko Gogoladze"
      ],
      "source": "https://fonts.ge/en/font/860/GL-Lortkipanidze-Regular",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "cef988f579611be15051877524888b2a245e8cad84b4e1352c65f120393cd3e7",
      "type": "font",
      "file": "fonts/860.ttf",
      "catalogId": "860"
    },
    {
      "id": "font:38",
      "name": "Gogebashvili-ITV",
      "family": "Gogebashvili-ITV",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/38/Gogebashvili-ITV",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "44f2117af096508f4aea855aecabc93647e772e07abb6e8d5c8c28c7da1f7ff6",
      "type": "font",
      "file": "fonts/38.ttf",
      "catalogId": "38"
    },
    {
      "id": "font:39",
      "name": "Gogebashvili-ITV Bold",
      "family": "Gogebashvili-ITV",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/39/Gogebashvili-ITV-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ba4e6e404f345f7b05c565c96d18cc73f8e1a97527a34280630400c8a628ba97",
      "type": "font",
      "file": "fonts/39.ttf",
      "catalogId": "39"
    },
    {
      "id": "font:41",
      "name": "Gogebashvili-ITV Bold Italic",
      "family": "Gogebashvili-ITV",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/41/Gogebashvili-ITV-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "beeff8e61b96b4a3c2a8b6fb58794d0532afd2a67b02689da31c69ac92d93b96",
      "type": "font",
      "file": "fonts/41.ttf",
      "catalogId": "41"
    },
    {
      "id": "font:40",
      "name": "Gogebashvili-ITV Italic",
      "family": "Gogebashvili-ITV",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/40/Gogebashvili-ITV-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "70f4742e8955aa5090c4198ec24d0f224d0270974d5eb7e3a8d3deea6f4799f2",
      "type": "font",
      "file": "fonts/40.ttf",
      "catalogId": "40"
    },
    {
      "id": "font:449",
      "name": "GrigoliaPolygraph",
      "family": "GrigoliaPolygraph",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/449/GrigoliaPolygraph",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "747bf926e18242df8e464b45154d00fca2b5dec7026c7fb8919ae13e709fc68c",
      "type": "font",
      "file": "fonts/449.ttf",
      "catalogId": "449"
    },
    {
      "id": "font:450",
      "name": "GrigoliaPolygraph Bold",
      "family": "GrigoliaPolygraph",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/450/GrigoliaPolygraph-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9d8c9f8fc6ae145c7d82a5b059dd48fe5ec0ac219c3bbf9ce579960221df5de0",
      "type": "font",
      "file": "fonts/450.ttf",
      "catalogId": "450"
    },
    {
      "id": "font:464",
      "name": "HKolkhetyMtav",
      "family": "HKolkhetyMtav",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Sandro Asatiani"
      ],
      "source": "https://fonts.ge/en/font/464/HKolkhetyMtav",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f4d190f3975be9b61c586e351bdd6627a724db504b9caf03455dad92863d0f3c",
      "type": "font",
      "file": "fonts/464.ttf",
      "catalogId": "464"
    },
    {
      "id": "font:465",
      "name": "HKolkhetyMtav Bold",
      "family": "HKolkhetyMtav",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Sandro Asatiani"
      ],
      "source": "https://fonts.ge/en/font/465/HKolkhetyMtav-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "263d6efae58631cb50faf546019e049b7d18533b86c06624cd160d4a025f1800",
      "type": "font",
      "file": "fonts/465.ttf",
      "catalogId": "465"
    },
    {
      "id": "font:473",
      "name": "Kolkhety",
      "family": "Kolkhety",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Medvedev"
      ],
      "source": "https://fonts.ge/en/font/473/Kolkhety",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "75c0c5137ba43b79a79a85d8679b04e550d85f4b605d7904fb5d6578ba829c9a",
      "type": "font",
      "file": "fonts/473.ttf",
      "catalogId": "473"
    },
    {
      "id": "font:474",
      "name": "Kolkhety Bold",
      "family": "Kolkhety",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Alexander Medvedev"
      ],
      "source": "https://fonts.ge/en/font/474/Kolkhety-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f7a8a5286724b9391d6ab95913f1a8cc2055004a562f445566edca8b45e696d4",
      "type": "font",
      "file": "fonts/474.ttf",
      "catalogId": "474"
    },
    {
      "id": "font:42",
      "name": "Kolkhety-ITV",
      "family": "Kolkhety-ITV",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/42/Kolkhety-ITV",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "538fdbe6d233e6b475cb10702904b5592dbaebcbc8f4bbadbc002771947ce02e",
      "type": "font",
      "file": "fonts/42.ttf",
      "catalogId": "42"
    },
    {
      "id": "font:43",
      "name": "Kolkhety-ITV Bold",
      "family": "Kolkhety-ITV",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/43/Kolkhety-ITV-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "6889d8e14654c7125eb610ad2897d267f55b212baf191abafb6e27a422538c86",
      "type": "font",
      "file": "fonts/43.ttf",
      "catalogId": "43"
    },
    {
      "id": "font:45",
      "name": "Kolkhety-ITV Bold Italic",
      "family": "Kolkhety-ITV",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/45/Kolkhety-ITV-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a3973b90f1c982c924299e14099da5d2e63981394528d70acffee5dce320f832",
      "type": "font",
      "file": "fonts/45.ttf",
      "catalogId": "45"
    },
    {
      "id": "font:44",
      "name": "Kolkhety-ITV Italic",
      "family": "Kolkhety-ITV",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/44/Kolkhety-ITV-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "28beb192ecedbf41ff666db8a6d47d251b4cd4397112a4d87288cdd61b7d31c4",
      "type": "font",
      "file": "fonts/44.ttf",
      "catalogId": "44"
    },
    {
      "id": "font:478",
      "name": "Literaturuli TD",
      "family": "Literaturuli-TD",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Deco Ltd"
      ],
      "source": "https://fonts.ge/en/font/478/Literaturuli-TD",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "a5de774263748a4873b68e95dd281ccdfedf39259fc34038306a9b1c79e772c2",
      "type": "font",
      "file": "fonts/478.ttf",
      "catalogId": "478"
    },
    {
      "id": "font:479",
      "name": "Literaturuli TD Bold",
      "family": "Literaturuli-TD",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Deco Ltd"
      ],
      "source": "https://fonts.ge/en/font/479/Literaturuli-TD-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "dce848c367e75f7f343e533725a915cfb2b76d009a3bf17b43fa800d1b8fe3b5",
      "type": "font",
      "file": "fonts/479.ttf",
      "catalogId": "479"
    },
    {
      "id": "font:481",
      "name": "Literaturuli TD Bold-Italic",
      "family": "Literaturuli-TD",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Deco Ltd"
      ],
      "source": "https://fonts.ge/en/font/481/Literaturuli-TD-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "197ba3caf63694a5cad81e467698557e49ccd593dcac960515fbbfccf8c9b7a9",
      "type": "font",
      "file": "fonts/481.ttf",
      "catalogId": "481"
    },
    {
      "id": "font:480",
      "name": "Literaturuli TD Italic",
      "family": "Literaturuli-TD",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Deco Ltd"
      ],
      "source": "https://fonts.ge/en/font/480/Literaturuli-TD-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "33c2dce8bc019337b02e90d21ca1cc1cdb9477a8f43f5d90a42c2acc5d1807e0",
      "type": "font",
      "file": "fonts/480.ttf",
      "catalogId": "480"
    },
    {
      "id": "font:46",
      "name": "Literaturuly-ITV",
      "family": "Literaturuly-ITV",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/46/Literaturuly-ITV",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "f9bf28a5098e3590aef00a37138c8e7bf728ebab67b42d53513c3a0f049a1a10",
      "type": "font",
      "file": "fonts/46.ttf",
      "catalogId": "46"
    },
    {
      "id": "font:47",
      "name": "Literaturuly-ITV Bold",
      "family": "Literaturuly-ITV",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/47/Literaturuly-ITV-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ac7dd96da83f4b9da670aecbcb77365be37c62e50ec1f568df62be94a2f847ca",
      "type": "font",
      "file": "fonts/47.ttf",
      "catalogId": "47"
    },
    {
      "id": "font:49",
      "name": "Literaturuly-ITV Bold Italic",
      "family": "Literaturuly-ITV",
      "style": "Bold Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/49/Literaturuly-ITV-Bold-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b9a460c2beabd8aeb629486c295ec15054f34f697cb3b1ae772360067c030cc0",
      "type": "font",
      "file": "fonts/49.ttf",
      "catalogId": "49"
    },
    {
      "id": "font:48",
      "name": "Literaturuly-ITV Italic",
      "family": "Literaturuly-ITV",
      "style": "Italic",
      "encoding": "Latin",
      "layout": "Russian [йцукен]",
      "writings": [
        "Mkhedruli Nuskhuri",
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Temur Imnaishvili",
        "Alexander Imnaishvili"
      ],
      "source": "https://fonts.ge/en/font/48/Literaturuly-ITV-Italic",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "fcab222a3b45a7790cd52ad62ff1dd90afdb4c1b5074ca2ff3c62beffad99e32",
      "type": "font",
      "file": "fonts/48.ttf",
      "catalogId": "48"
    },
    {
      "id": "font:659",
      "name": "LiterMtavr",
      "family": "LiterMtavr",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/659/LiterMtavr",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "3442675b52ff6ef5861fcec146c955f2b5c508cf535634022de649792888b6c9",
      "type": "font",
      "file": "fonts/659.ttf",
      "catalogId": "659"
    },
    {
      "id": "font:660",
      "name": "LiterMtavr Bold",
      "family": "LiterMtavr",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/660/LiterMtavr-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "6406bcb466e1da31bad7b0fe0ea706e8bb4466b065570f7664e54d8c145ab08e",
      "type": "font",
      "file": "fonts/660.ttf",
      "catalogId": "660"
    },
    {
      "id": "font:658",
      "name": "LiterNusx Bold",
      "family": "LiterNusx",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/658/LiterNusx-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0aba6790ad769c2b0f283c849cad8a99b6e72a5b2657f061735204410d6bd5a7",
      "type": "font",
      "file": "fonts/658.ttf",
      "catalogId": "658"
    },
    {
      "id": "font:657",
      "name": "LiterNusx Normal",
      "family": "LiterNusx",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Levan Berdzenishvili"
      ],
      "source": "https://fonts.ge/en/font/657/LiterNusx-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "48fcd94e3f0849da830d542cb104edc687f47af3b8f77b88e4f66c22d426e530",
      "type": "font",
      "file": "fonts/657.ttf",
      "catalogId": "657"
    },
    {
      "id": "font:496",
      "name": "metroff",
      "family": "metroff",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "esoffice"
      ],
      "source": "https://fonts.ge/en/font/496/metroff",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "15bcad8406c45cdda3d4b25e5e6ba73510741322cd2606a4f89b1a153d0c6f21",
      "type": "font",
      "file": "fonts/496.ttf",
      "catalogId": "496"
    },
    {
      "id": "font:628",
      "name": "metroffM",
      "family": "metroff",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "esoffice"
      ],
      "source": "https://fonts.ge/en/font/628/metroffM",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ef4a8691de5de1578fa9c1abb624fab603dfce923db2a5759ec8b6313b65b607",
      "type": "font",
      "file": "fonts/628.ttf",
      "catalogId": "628"
    },
    {
      "id": "font:520",
      "name": "SokolxeTy",
      "family": "SokolxeTy",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/520/SokolxeTy",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8529930616e52f72fc201224e2ecf8c727e499426dbc9cfe10dfabceabc17c12",
      "type": "font",
      "file": "fonts/520.ttf",
      "catalogId": "520"
    },
    {
      "id": "font:521",
      "name": "SokolxeTy Bold",
      "family": "SokolxeTy",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/521/SokolxeTy-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "1f6778cac5dd0218b4b7ba26e1c924a1a7088655447f58f46516edc1643c9e47",
      "type": "font",
      "file": "fonts/521.ttf",
      "catalogId": "521"
    },
    {
      "id": "font:522",
      "name": "SPAcademi",
      "family": "SPAcademi",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/522/SPAcademi",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "d760f45776f647511d1b89241f0c01499239b797fbc61e8131e2555b081e5bc7",
      "type": "font",
      "file": "fonts/522.ttf",
      "catalogId": "522"
    },
    {
      "id": "font:523",
      "name": "SPAcademi Bold",
      "family": "SPAcademi",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/523/SPAcademi-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5b063bf6b9cd395d5146436e5f5443248cc6b913a539c92bb8d6bc0e260a26c5",
      "type": "font",
      "file": "fonts/523.ttf",
      "catalogId": "523"
    },
    {
      "id": "font:525",
      "name": "SPAcademi MT",
      "family": "SPAcademi MT",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/525/SPAcademi-MT",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "10d762dd05a9b47db9abae1929a027dda9dc1f4211a06c3dc43a47b36c9bbc14",
      "type": "font",
      "file": "fonts/525.ttf",
      "catalogId": "525"
    },
    {
      "id": "font:524",
      "name": "SPAcademi MT Bold",
      "family": "SPAcademi MT",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/524/SPAcademi-MT-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "58f58965d3940c6987a936df70c969e62a4629a55bc2dc67282d02d79c2a0bdf",
      "type": "font",
      "file": "fonts/524.ttf",
      "catalogId": "524"
    },
    {
      "id": "font:528",
      "name": "SPChveulebrivi Bold",
      "family": "SPChveulebrivi",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/528/SPChveulebrivi-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "cef3dd7bac7e056e3b0c196304bcecfb4dd48be84a715c90077ab8089b140b48",
      "type": "font",
      "file": "fonts/528.ttf",
      "catalogId": "528"
    },
    {
      "id": "font:527",
      "name": "SPChveulebrivi Medium",
      "family": "SPChveulebrivi",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/527/SPChveulebrivi-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "9bfef6c5ced22b942b41698d56ddc1e440f79c4c7b700e631dc04f51d97a69d5",
      "type": "font",
      "file": "fonts/527.ttf",
      "catalogId": "527"
    },
    {
      "id": "font:530",
      "name": "SPChveulebriviMT Bold",
      "family": "SPChveulebriviMT",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/530/SPChveulebriviMT-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "c4e982b76f0c6cc9797b6d15f32aada2c3f3d9bdbaec20843e8beee96d14c56a",
      "type": "font",
      "file": "fonts/530.ttf",
      "catalogId": "530"
    },
    {
      "id": "font:529",
      "name": "SPChveulebriviMT Medium",
      "family": "SPChveulebriviMT",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/529/SPChveulebriviMT-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "43395577cb66c4866e4e17491b1b4ad5c8620d7a0cb00b98e67ba9bedb6b198b",
      "type": "font",
      "file": "fonts/529.ttf",
      "catalogId": "529"
    },
    {
      "id": "font:537",
      "name": "SPGrigolia",
      "family": "SPGrigolia",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/537/SPGrigolia",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4c4413c266eb7628038dfca5f8bd133ef817dcade936f4248179f2bab59409f4",
      "type": "font",
      "file": "fonts/537.ttf",
      "catalogId": "537"
    },
    {
      "id": "font:538",
      "name": "SPGrigolia Bold",
      "family": "SPGrigolia",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/538/SPGrigolia-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "39cae09c6134b9ddaa7e4997b2e56e8eee2590e6cd93c9b1d0afe11d5e20dc6f",
      "type": "font",
      "file": "fonts/538.ttf",
      "catalogId": "538"
    },
    {
      "id": "font:539",
      "name": "SPGrigolia MT",
      "family": "SPGrigolia MT",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/539/SPGrigolia-MT",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0caacc5639aa5035820407ef44aa7c8f995ec523ee68880581181ee6fba88ee9",
      "type": "font",
      "file": "fonts/539.ttf",
      "catalogId": "539"
    },
    {
      "id": "font:540",
      "name": "SPGrigolia MT Bold",
      "family": "SPGrigolia MT",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/540/SPGrigolia-MT-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2c2a86b19a81d45308e78440940d50eced47fa6d9d22504326e0380df01c43b5",
      "type": "font",
      "file": "fonts/540.ttf",
      "catalogId": "540"
    },
    {
      "id": "font:543",
      "name": "SPKolheti Bold",
      "family": "SPKolheti",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/543/SPKolheti-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b6dff4f2bb8dfd6b2f6896e5f6da38634dc511ba9221338694983580811f568a",
      "type": "font",
      "file": "fonts/543.ttf",
      "catalogId": "543"
    },
    {
      "id": "font:542",
      "name": "SPKolheti Medium",
      "family": "SPKolheti",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/542/SPKolheti-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "b93c60f40e0b170c6f7501326288ac94288f31a579c3403b0dad9fd888c78f25",
      "type": "font",
      "file": "fonts/542.ttf",
      "catalogId": "542"
    },
    {
      "id": "font:545",
      "name": "SPKolhetiMT Bold",
      "family": "SPKolhetiMT",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/545/SPKolhetiMT-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "0de192189ad78db4f6ed1315d5ae834805d9f1150926f838727d0fd7b05ec1aa",
      "type": "font",
      "file": "fonts/545.ttf",
      "catalogId": "545"
    },
    {
      "id": "font:544",
      "name": "SPKolhetiMT Medium",
      "family": "SPKolhetiMT",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/544/SPKolhetiMT-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "ac41551d3c85e2b1e0ed1f6ac8c3acc6875f592392a980425eb842b48b7700cb",
      "type": "font",
      "file": "fonts/544.ttf",
      "catalogId": "544"
    },
    {
      "id": "font:546",
      "name": "SPLiteraturuly",
      "family": "SPLiteraturuly",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/546/SPLiteraturuly",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2dd507796cb9d8471aade7e85654e16b072bb333cc490e6510e0ee024e580173",
      "type": "font",
      "file": "fonts/546.ttf",
      "catalogId": "546"
    },
    {
      "id": "font:547",
      "name": "SPLiteraturuly Bold",
      "family": "SPLiteraturuly",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/547/SPLiteraturuly-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "4098678ab069cf2d9ec661602c7f2f46993301885bbd1f413fdcac145246d8ac",
      "type": "font",
      "file": "fonts/547.ttf",
      "catalogId": "547"
    },
    {
      "id": "font:552",
      "name": "SPParliament Bold",
      "family": "SPParliament",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/552/SPParliament-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "12d82f88d5de95151f07d4ec1357348354360da577801004b9faad05c3a7b939",
      "type": "font",
      "file": "fonts/552.ttf",
      "catalogId": "552"
    },
    {
      "id": "font:551",
      "name": "SPParliament Medium",
      "family": "SPParliament",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/551/SPParliament-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "2429c0dc4e45bd3928985abfbe2812402f2daeeed59dbfa3e7910555c3bfd4b8",
      "type": "font",
      "file": "fonts/551.ttf",
      "catalogId": "551"
    },
    {
      "id": "font:554",
      "name": "SPParliamentMT Bold",
      "family": "SPParliamentMT",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/554/SPParliamentMT-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "fd0ec9c74f4addb59247d587184d5dd90cdb4f03546e1129354028e6c366a96d",
      "type": "font",
      "file": "fonts/554.ttf",
      "catalogId": "554"
    },
    {
      "id": "font:553",
      "name": "SPParliamentMT Medium",
      "family": "SPParliamentMT",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/553/SPParliamentMT-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "fd2309f94a88a64c7f8b8f844ec05607a3a9b43ba3dc3a419cb5882df0b67b24",
      "type": "font",
      "file": "fonts/553.ttf",
      "catalogId": "553"
    },
    {
      "id": "font:558",
      "name": "SPSiradze",
      "family": "SPSiradze",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/558/SPSiradze",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "46592d4217ce356807db71638bd5e7315290ca832ad7dabb1faa1d0ba4e2415c",
      "type": "font",
      "file": "fonts/558.ttf",
      "catalogId": "558"
    },
    {
      "id": "font:559",
      "name": "SPSiradze Bold",
      "family": "SPSiradze",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/559/SPSiradze-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "8192cc25f79c2ea42d135c755f59f9cf61e681250903893de5475f7bc7ad55eb",
      "type": "font",
      "file": "fonts/559.ttf",
      "catalogId": "559"
    },
    {
      "id": "font:561",
      "name": "SPVena Bold",
      "family": "SPVena",
      "style": "Bold",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/561/SPVena-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "191281a4b604c7ca1563596eaeb0b0f84ef3211c427dde5d3089b02acd4aadc2",
      "type": "font",
      "file": "fonts/561.ttf",
      "catalogId": "561"
    },
    {
      "id": "font:560",
      "name": "SPVena Medium",
      "family": "SPVena",
      "style": "Regular",
      "encoding": "STD8 (Geo, SP)",
      "layout": "Driver dependent",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Soma Press Ltd"
      ],
      "source": "https://fonts.ge/en/font/560/SPVena-Medium",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "05648fa85ac58abeabe0fa7a8be21475aaa2fd1a158ee378081eaadd3e7cabe5",
      "type": "font",
      "file": "fonts/560.ttf",
      "catalogId": "560"
    },
    {
      "id": "font:615",
      "name": "Titus Mxedruli Bold",
      "family": "Titus Mxedruli",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Unknown",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Jogi Weichware"
      ],
      "source": "https://fonts.ge/en/font/615/Titus-Mxedruli-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e6c4fc880dfba7b2cea719c3dfd240b26390e7a6cb6793195e99bca457c76361",
      "type": "font",
      "file": "fonts/615.ttf",
      "catalogId": "615"
    },
    {
      "id": "font:614",
      "name": "Titus Mxedruli Normal",
      "family": "Titus Mxedruli",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Unknown",
      "writings": [
        "Mkhedruli Nuskhuri"
      ],
      "authors": [
        "Jogi Weichware"
      ],
      "source": "https://fonts.ge/en/font/614/Titus-Mxedruli-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "7d6dc6ff85571908276899b0bdf8e5b85250a52cb2fb0708e8e4ec0cbd0b9ea0",
      "type": "font",
      "file": "fonts/614.ttf",
      "catalogId": "614"
    },
    {
      "id": "font:736",
      "name": "_! KolhetyMt Bold",
      "family": "_! KolhetyMt",
      "style": "Bold",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/736/-%21-KolhetyMt-Bold",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "5b243ac819353354c409e44d11fb3e766ddd1c22bcdccaa691754860ff063139",
      "type": "font",
      "file": "fonts/736.ttf",
      "catalogId": "736"
    },
    {
      "id": "font:735",
      "name": "_! KolhetyMt Normal",
      "family": "_! KolhetyMt",
      "style": "Regular",
      "encoding": "Latin",
      "layout": "Latin [qwerty]",
      "writings": [
        "Mkhedruli Mtavruli"
      ],
      "authors": [
        "Unknown"
      ],
      "source": "https://fonts.ge/en/font/735/-%21-KolhetyMt-Normal",
      "licenseText": null,
      "licenseUrl": null,
      "licenseCopyright": null,
      "sha256": "e9d1bbdd329c2ee57753633dc525929c1eb15aae61316e48a4b34f5d8c251c52",
      "type": "font",
      "file": "fonts/735.ttf",
      "catalogId": "735"
    }
  ],
  "links": [
    {
      "source": "pack:001-unicode-starter-collection",
      "target": "font:727",
      "relation": "contains"
    },
    {
      "source": "pack:001-unicode-starter-collection",
      "target": "font:696",
      "relation": "contains"
    },
    {
      "source": "pack:001-unicode-starter-collection",
      "target": "font:703",
      "relation": "contains"
    },
    {
      "source": "pack:001-unicode-starter-collection",
      "target": "font:704",
      "relation": "contains"
    },
    {
      "source": "pack:001-unicode-starter-collection",
      "target": "font:905",
      "relation": "contains"
    },
    {
      "source": "pack:001-unicode-starter-collection",
      "target": "font:906",
      "relation": "contains"
    },
    {
      "source": "pack:002-georgian-headline-collection",
      "target": "font:705",
      "relation": "contains"
    },
    {
      "source": "pack:002-georgian-headline-collection",
      "target": "font:707",
      "relation": "contains"
    },
    {
      "source": "pack:002-georgian-headline-collection",
      "target": "font:708",
      "relation": "contains"
    },
    {
      "source": "pack:002-georgian-headline-collection",
      "target": "font:712",
      "relation": "contains"
    },
    {
      "source": "pack:002-georgian-headline-collection",
      "target": "font:715",
      "relation": "contains"
    },
    {
      "source": "pack:002-georgian-headline-collection",
      "target": "font:719",
      "relation": "contains"
    },
    {
      "source": "pack:003-ar-archy-weight-collection",
      "target": "font:700",
      "relation": "contains"
    },
    {
      "source": "pack:003-ar-archy-weight-collection",
      "target": "font:696",
      "relation": "contains"
    },
    {
      "source": "pack:003-ar-archy-weight-collection",
      "target": "font:701",
      "relation": "contains"
    },
    {
      "source": "pack:003-ar-archy-weight-collection",
      "target": "font:702",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:712",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:713",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:714",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:715",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:716",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:717",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:718",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:719",
      "relation": "contains"
    },
    {
      "source": "pack:004-bpg-banner-collection",
      "target": "font:720",
      "relation": "contains"
    },
    {
      "source": "pack:005-aaacademiury-std8-geo-sp",
      "target": "font:56",
      "relation": "contains"
    },
    {
      "source": "pack:005-aaacademiury-std8-geo-sp",
      "target": "font:57",
      "relation": "contains"
    },
    {
      "source": "pack:006-academiury-a-v-latin",
      "target": "font:63",
      "relation": "contains"
    },
    {
      "source": "pack:006-academiury-a-v-latin",
      "target": "font:64",
      "relation": "contains"
    },
    {
      "source": "pack:007-akademiuri-latin",
      "target": "font:70",
      "relation": "contains"
    },
    {
      "source": "pack:007-akademiuri-latin",
      "target": "font:71",
      "relation": "contains"
    },
    {
      "source": "pack:008-akolkhetyn-latin",
      "target": "font:688",
      "relation": "contains"
    },
    {
      "source": "pack:008-akolkhetyn-latin",
      "target": "font:689",
      "relation": "contains"
    },
    {
      "source": "pack:008-akolkhetyn-latin",
      "target": "font:691",
      "relation": "contains"
    },
    {
      "source": "pack:008-akolkhetyn-latin",
      "target": "font:690",
      "relation": "contains"
    },
    {
      "source": "pack:009-alk-rounded-unicode-utf-8",
      "target": "font:685",
      "relation": "contains"
    },
    {
      "source": "pack:009-alk-rounded-unicode-utf-8",
      "target": "font:684",
      "relation": "contains"
    },
    {
      "source": "pack:010-alva-latin",
      "target": "font:775",
      "relation": "contains"
    },
    {
      "source": "pack:010-alva-latin",
      "target": "font:774",
      "relation": "contains"
    },
    {
      "source": "pack:011-ar-archy-unicode-utf-8",
      "target": "font:700",
      "relation": "contains"
    },
    {
      "source": "pack:011-ar-archy-unicode-utf-8",
      "target": "font:696",
      "relation": "contains"
    },
    {
      "source": "pack:011-ar-archy-unicode-utf-8",
      "target": "font:701",
      "relation": "contains"
    },
    {
      "source": "pack:011-ar-archy-unicode-utf-8",
      "target": "font:702",
      "relation": "contains"
    },
    {
      "source": "pack:012-archy-edt-unicode-utf-8",
      "target": "font:744",
      "relation": "contains"
    },
    {
      "source": "pack:012-archy-edt-unicode-utf-8",
      "target": "font:743",
      "relation": "contains"
    },
    {
      "source": "pack:013-arial-geo-unicode-utf-8",
      "target": "font:78",
      "relation": "contains"
    },
    {
      "source": "pack:013-arial-geo-unicode-utf-8",
      "target": "font:721",
      "relation": "contains"
    },
    {
      "source": "pack:013-arial-geo-unicode-utf-8",
      "target": "font:723",
      "relation": "contains"
    },
    {
      "source": "pack:013-arial-geo-unicode-utf-8",
      "target": "font:722",
      "relation": "contains"
    },
    {
      "source": "pack:014-azacademiury-std8-geo-sp",
      "target": "font:84",
      "relation": "contains"
    },
    {
      "source": "pack:014-azacademiury-std8-geo-sp",
      "target": "font:85",
      "relation": "contains"
    },
    {
      "source": "pack:014-azacademiury-std8-geo-sp",
      "target": "font:87",
      "relation": "contains"
    },
    {
      "source": "pack:014-azacademiury-std8-geo-sp",
      "target": "font:86",
      "relation": "contains"
    },
    {
      "source": "pack:015-babuka-latin",
      "target": "font:89",
      "relation": "contains"
    },
    {
      "source": "pack:015-babuka-latin",
      "target": "font:90",
      "relation": "contains"
    },
    {
      "source": "pack:016-bakuri-unicode-utf-8",
      "target": "font:906",
      "relation": "contains"
    },
    {
      "source": "pack:016-bakuri-unicode-utf-8",
      "target": "font:905",
      "relation": "contains"
    },
    {
      "source": "pack:017-bolnisi-latin",
      "target": "font:94",
      "relation": "contains"
    },
    {
      "source": "pack:017-bolnisi-latin",
      "target": "font:95",
      "relation": "contains"
    },
    {
      "source": "pack:018-bpg-extrasquare-unicode-utf-8",
      "target": "font:14",
      "relation": "contains"
    },
    {
      "source": "pack:018-bpg-extrasquare-unicode-utf-8",
      "target": "font:15",
      "relation": "contains"
    },
    {
      "source": "pack:019-bpg-glaho-unicode-utf-8",
      "target": "font:1",
      "relation": "contains"
    },
    {
      "source": "pack:019-bpg-glaho-unicode-utf-8",
      "target": "font:114",
      "relation": "contains"
    },
    {
      "source": "pack:020-bpg-phone-sans-unicode-utf-8",
      "target": "font:489",
      "relation": "contains"
    },
    {
      "source": "pack:020-bpg-phone-sans-unicode-utf-8",
      "target": "font:490",
      "relation": "contains"
    },
    {
      "source": "pack:020-bpg-phone-sans-unicode-utf-8",
      "target": "font:491",
      "relation": "contains"
    },
    {
      "source": "pack:020-bpg-phone-sans-unicode-utf-8",
      "target": "font:492",
      "relation": "contains"
    },
    {
      "source": "pack:021-bpg-serif-unicode-utf-8",
      "target": "font:179",
      "relation": "contains"
    },
    {
      "source": "pack:021-bpg-serif-unicode-utf-8",
      "target": "font:178",
      "relation": "contains"
    },
    {
      "source": "pack:022-chveulebrivi-td-latin",
      "target": "font:195",
      "relation": "contains"
    },
    {
      "source": "pack:022-chveulebrivi-td-latin",
      "target": "font:194",
      "relation": "contains"
    },
    {
      "source": "pack:022-chveulebrivi-td-latin",
      "target": "font:197",
      "relation": "contains"
    },
    {
      "source": "pack:022-chveulebrivi-td-latin",
      "target": "font:196",
      "relation": "contains"
    },
    {
      "source": "pack:023-chveulebrivy-itv-latin",
      "target": "font:26",
      "relation": "contains"
    },
    {
      "source": "pack:023-chveulebrivy-itv-latin",
      "target": "font:27",
      "relation": "contains"
    },
    {
      "source": "pack:023-chveulebrivy-itv-latin",
      "target": "font:29",
      "relation": "contains"
    },
    {
      "source": "pack:023-chveulebrivy-itv-latin",
      "target": "font:28",
      "relation": "contains"
    },
    {
      "source": "pack:024-dara1981-mt-latin",
      "target": "font:788",
      "relation": "contains"
    },
    {
      "source": "pack:024-dara1981-mt-latin",
      "target": "font:787",
      "relation": "contains"
    },
    {
      "source": "pack:025-dara1981-nus-latin",
      "target": "font:786",
      "relation": "contains"
    },
    {
      "source": "pack:025-dara1981-nus-latin",
      "target": "font:785",
      "relation": "contains"
    },
    {
      "source": "pack:026-dejavu-sans-unicode-utf-8",
      "target": "font:793",
      "relation": "contains"
    },
    {
      "source": "pack:026-dejavu-sans-unicode-utf-8",
      "target": "font:795",
      "relation": "contains"
    },
    {
      "source": "pack:026-dejavu-sans-unicode-utf-8",
      "target": "font:792",
      "relation": "contains"
    },
    {
      "source": "pack:026-dejavu-sans-unicode-utf-8",
      "target": "font:796",
      "relation": "contains"
    },
    {
      "source": "pack:026-dejavu-sans-unicode-utf-8",
      "target": "font:794",
      "relation": "contains"
    },
    {
      "source": "pack:027-dumbadze-itv-latin",
      "target": "font:34",
      "relation": "contains"
    },
    {
      "source": "pack:027-dumbadze-itv-latin",
      "target": "font:35",
      "relation": "contains"
    },
    {
      "source": "pack:027-dumbadze-itv-latin",
      "target": "font:37",
      "relation": "contains"
    },
    {
      "source": "pack:027-dumbadze-itv-latin",
      "target": "font:36",
      "relation": "contains"
    },
    {
      "source": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "target": "font:811",
      "relation": "contains"
    },
    {
      "source": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "target": "font:813",
      "relation": "contains"
    },
    {
      "source": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "target": "font:814",
      "relation": "contains"
    },
    {
      "source": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "target": "font:815",
      "relation": "contains"
    },
    {
      "source": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "target": "font:812",
      "relation": "contains"
    },
    {
      "source": "pack:028-eurostile-lt-std-geo-mt-unicode-utf-8",
      "target": "font:810",
      "relation": "contains"
    },
    {
      "source": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "target": "font:805",
      "relation": "contains"
    },
    {
      "source": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "target": "font:807",
      "relation": "contains"
    },
    {
      "source": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "target": "font:808",
      "relation": "contains"
    },
    {
      "source": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "target": "font:809",
      "relation": "contains"
    },
    {
      "source": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "target": "font:806",
      "relation": "contains"
    },
    {
      "source": "pack:029-eurostile-lt-std-geo-nus-unicode-utf-8",
      "target": "font:804",
      "relation": "contains"
    },
    {
      "source": "pack:030-g-g-ilia-latin",
      "target": "font:219",
      "relation": "contains"
    },
    {
      "source": "pack:030-g-g-ilia-latin",
      "target": "font:218",
      "relation": "contains"
    },
    {
      "source": "pack:031-g-g-iliam-latin",
      "target": "font:220",
      "relation": "contains"
    },
    {
      "source": "pack:031-g-g-iliam-latin",
      "target": "font:221",
      "relation": "contains"
    },
    {
      "source": "pack:032-g-g-illliam-latin",
      "target": "font:223",
      "relation": "contains"
    },
    {
      "source": "pack:032-g-g-illliam-latin",
      "target": "font:222",
      "relation": "contains"
    },
    {
      "source": "pack:033-g-g-kolhety-latin",
      "target": "font:224",
      "relation": "contains"
    },
    {
      "source": "pack:033-g-g-kolhety-latin",
      "target": "font:225",
      "relation": "contains"
    },
    {
      "source": "pack:034-geo-acadmtavr-latin",
      "target": "font:229",
      "relation": "contains"
    },
    {
      "source": "pack:034-geo-acadmtavr-latin",
      "target": "font:230",
      "relation": "contains"
    },
    {
      "source": "pack:035-geo-acadnusx-latin",
      "target": "font:232",
      "relation": "contains"
    },
    {
      "source": "pack:035-geo-acadnusx-latin",
      "target": "font:231",
      "relation": "contains"
    },
    {
      "source": "pack:036-geo-chveumtavr-latin",
      "target": "font:250",
      "relation": "contains"
    },
    {
      "source": "pack:036-geo-chveumtavr-latin",
      "target": "font:249",
      "relation": "contains"
    },
    {
      "source": "pack:037-geo-chveunusx-latin",
      "target": "font:252",
      "relation": "contains"
    },
    {
      "source": "pack:037-geo-chveunusx-latin",
      "target": "font:251",
      "relation": "contains"
    },
    {
      "source": "pack:038-geo-dumbadze-mtavr-latin",
      "target": "font:259",
      "relation": "contains"
    },
    {
      "source": "pack:038-geo-dumbadze-mtavr-latin",
      "target": "font:260",
      "relation": "contains"
    },
    {
      "source": "pack:038-geo-dumbadze-mtavr-latin",
      "target": "font:261",
      "relation": "contains"
    },
    {
      "source": "pack:039-geo-dumbadze-nusx-latin",
      "target": "font:263",
      "relation": "contains"
    },
    {
      "source": "pack:039-geo-dumbadze-nusx-latin",
      "target": "font:264",
      "relation": "contains"
    },
    {
      "source": "pack:039-geo-dumbadze-nusx-latin",
      "target": "font:265",
      "relation": "contains"
    },
    {
      "source": "pack:040-geo-grigolia-mtavr-latin",
      "target": "font:277",
      "relation": "contains"
    },
    {
      "source": "pack:040-geo-grigolia-mtavr-latin",
      "target": "font:278",
      "relation": "contains"
    },
    {
      "source": "pack:041-geo-grigolia-nusx-latin",
      "target": "font:279",
      "relation": "contains"
    },
    {
      "source": "pack:041-geo-grigolia-nusx-latin",
      "target": "font:280",
      "relation": "contains"
    },
    {
      "source": "pack:042-geo-grigoliapolygraph-latin",
      "target": "font:281",
      "relation": "contains"
    },
    {
      "source": "pack:042-geo-grigoliapolygraph-latin",
      "target": "font:282",
      "relation": "contains"
    },
    {
      "source": "pack:043-geo-ilia-mtavr-latin",
      "target": "font:285",
      "relation": "contains"
    },
    {
      "source": "pack:043-geo-ilia-mtavr-latin",
      "target": "font:284",
      "relation": "contains"
    },
    {
      "source": "pack:044-geo-ilia-nusx-latin",
      "target": "font:287",
      "relation": "contains"
    },
    {
      "source": "pack:044-geo-ilia-nusx-latin",
      "target": "font:286",
      "relation": "contains"
    },
    {
      "source": "pack:045-geo-kolkheti-mtavr-latin",
      "target": "font:296",
      "relation": "contains"
    },
    {
      "source": "pack:045-geo-kolkheti-mtavr-latin",
      "target": "font:295",
      "relation": "contains"
    },
    {
      "source": "pack:046-geo-kolkheti-nusx-latin",
      "target": "font:297",
      "relation": "contains"
    },
    {
      "source": "pack:046-geo-kolkheti-nusx-latin",
      "target": "font:298",
      "relation": "contains"
    },
    {
      "source": "pack:047-geo-literaturuly-n-std8-geo-sp",
      "target": "font:388",
      "relation": "contains"
    },
    {
      "source": "pack:047-geo-literaturuly-n-std8-geo-sp",
      "target": "font:390",
      "relation": "contains"
    },
    {
      "source": "pack:047-geo-literaturuly-n-std8-geo-sp",
      "target": "font:391",
      "relation": "contains"
    },
    {
      "source": "pack:047-geo-literaturuly-n-std8-geo-sp",
      "target": "font:389",
      "relation": "contains"
    },
    {
      "source": "pack:048-geo-litermtavr-latin",
      "target": "font:303",
      "relation": "contains"
    },
    {
      "source": "pack:048-geo-litermtavr-latin",
      "target": "font:302",
      "relation": "contains"
    },
    {
      "source": "pack:049-geo-liternusx-latin",
      "target": "font:305",
      "relation": "contains"
    },
    {
      "source": "pack:049-geo-liternusx-latin",
      "target": "font:304",
      "relation": "contains"
    },
    {
      "source": "pack:050-latin",
      "target": "font:316",
      "relation": "contains"
    },
    {
      "source": "pack:050-latin",
      "target": "font:16",
      "relation": "contains"
    },
    {
      "source": "pack:051-geodumba-latin",
      "target": "font:408",
      "relation": "contains"
    },
    {
      "source": "pack:051-geodumba-latin",
      "target": "font:410",
      "relation": "contains"
    },
    {
      "source": "pack:051-geodumba-latin",
      "target": "font:409",
      "relation": "contains"
    },
    {
      "source": "pack:052-geoedumba-latin",
      "target": "font:413",
      "relation": "contains"
    },
    {
      "source": "pack:052-geoedumba-latin",
      "target": "font:415",
      "relation": "contains"
    },
    {
      "source": "pack:052-geoedumba-latin",
      "target": "font:414",
      "relation": "contains"
    },
    {
      "source": "pack:053-georgian-times-std8-geo-sp",
      "target": "font:421",
      "relation": "contains"
    },
    {
      "source": "pack:053-georgian-times-std8-geo-sp",
      "target": "font:420",
      "relation": "contains"
    },
    {
      "source": "pack:054-geo-academiuri-std8-geo-sp",
      "target": "font:363",
      "relation": "contains"
    },
    {
      "source": "pack:054-geo-academiuri-std8-geo-sp",
      "target": "font:364",
      "relation": "contains"
    },
    {
      "source": "pack:055-geo-arial-std8-geo-sp",
      "target": "font:366",
      "relation": "contains"
    },
    {
      "source": "pack:055-geo-arial-std8-geo-sp",
      "target": "font:367",
      "relation": "contains"
    },
    {
      "source": "pack:055-geo-arial-std8-geo-sp",
      "target": "font:369",
      "relation": "contains"
    },
    {
      "source": "pack:055-geo-arial-std8-geo-sp",
      "target": "font:368",
      "relation": "contains"
    },
    {
      "source": "pack:056-geo-courier-std8-geo-sp",
      "target": "font:370",
      "relation": "contains"
    },
    {
      "source": "pack:056-geo-courier-std8-geo-sp",
      "target": "font:371",
      "relation": "contains"
    },
    {
      "source": "pack:056-geo-courier-std8-geo-sp",
      "target": "font:373",
      "relation": "contains"
    },
    {
      "source": "pack:056-geo-courier-std8-geo-sp",
      "target": "font:372",
      "relation": "contains"
    },
    {
      "source": "pack:057-geo-dumbadze-std8-geo-sp",
      "target": "font:374",
      "relation": "contains"
    },
    {
      "source": "pack:057-geo-dumbadze-std8-geo-sp",
      "target": "font:375",
      "relation": "contains"
    },
    {
      "source": "pack:058-geo-kolkheti-std8-geo-sp",
      "target": "font:379",
      "relation": "contains"
    },
    {
      "source": "pack:058-geo-kolkheti-std8-geo-sp",
      "target": "font:380",
      "relation": "contains"
    },
    {
      "source": "pack:058-geo-kolkheti-std8-geo-sp",
      "target": "font:382",
      "relation": "contains"
    },
    {
      "source": "pack:058-geo-kolkheti-std8-geo-sp",
      "target": "font:381",
      "relation": "contains"
    },
    {
      "source": "pack:059-geo-literaturuli-std8-geo-sp",
      "target": "font:384",
      "relation": "contains"
    },
    {
      "source": "pack:059-geo-literaturuli-std8-geo-sp",
      "target": "font:385",
      "relation": "contains"
    },
    {
      "source": "pack:059-geo-literaturuli-std8-geo-sp",
      "target": "font:387",
      "relation": "contains"
    },
    {
      "source": "pack:059-geo-literaturuli-std8-geo-sp",
      "target": "font:386",
      "relation": "contains"
    },
    {
      "source": "pack:060-geo-times-std8-geo-sp",
      "target": "font:5",
      "relation": "contains"
    },
    {
      "source": "pack:060-geo-times-std8-geo-sp",
      "target": "font:10",
      "relation": "contains"
    },
    {
      "source": "pack:060-geo-times-std8-geo-sp",
      "target": "font:12",
      "relation": "contains"
    },
    {
      "source": "pack:060-geo-times-std8-geo-sp",
      "target": "font:11",
      "relation": "contains"
    },
    {
      "source": "pack:061-geo-venuri-std8-geo-sp",
      "target": "font:394",
      "relation": "contains"
    },
    {
      "source": "pack:061-geo-venuri-std8-geo-sp",
      "target": "font:395",
      "relation": "contains"
    },
    {
      "source": "pack:061-geo-venuri-std8-geo-sp",
      "target": "font:397",
      "relation": "contains"
    },
    {
      "source": "pack:061-geo-venuri-std8-geo-sp",
      "target": "font:396",
      "relation": "contains"
    },
    {
      "source": "pack:062-geo-www-courier-std8-geo-sp",
      "target": "font:398",
      "relation": "contains"
    },
    {
      "source": "pack:062-geo-www-courier-std8-geo-sp",
      "target": "font:399",
      "relation": "contains"
    },
    {
      "source": "pack:062-geo-www-courier-std8-geo-sp",
      "target": "font:401",
      "relation": "contains"
    },
    {
      "source": "pack:062-geo-www-courier-std8-geo-sp",
      "target": "font:400",
      "relation": "contains"
    },
    {
      "source": "pack:063-geo-www-times-std8-geo-sp",
      "target": "font:402",
      "relation": "contains"
    },
    {
      "source": "pack:063-geo-www-times-std8-geo-sp",
      "target": "font:403",
      "relation": "contains"
    },
    {
      "source": "pack:063-geo-www-times-std8-geo-sp",
      "target": "font:405",
      "relation": "contains"
    },
    {
      "source": "pack:063-geo-www-times-std8-geo-sp",
      "target": "font:404",
      "relation": "contains"
    },
    {
      "source": "pack:064-gf-aisi-mt-unicode-utf-8",
      "target": "font:758",
      "relation": "contains"
    },
    {
      "source": "pack:064-gf-aisi-mt-unicode-utf-8",
      "target": "font:760",
      "relation": "contains"
    },
    {
      "source": "pack:064-gf-aisi-mt-unicode-utf-8",
      "target": "font:759",
      "relation": "contains"
    },
    {
      "source": "pack:064-gf-aisi-mt-unicode-utf-8",
      "target": "font:757",
      "relation": "contains"
    },
    {
      "source": "pack:065-gf-aisi-mt-light-unicode-utf-8",
      "target": "font:763",
      "relation": "contains"
    },
    {
      "source": "pack:065-gf-aisi-mt-light-unicode-utf-8",
      "target": "font:764",
      "relation": "contains"
    },
    {
      "source": "pack:066-gf-aisi-mt-medium-unicode-utf-8",
      "target": "font:761",
      "relation": "contains"
    },
    {
      "source": "pack:066-gf-aisi-mt-medium-unicode-utf-8",
      "target": "font:762",
      "relation": "contains"
    },
    {
      "source": "pack:067-gf-aisi-nus-unicode-utf-8",
      "target": "font:766",
      "relation": "contains"
    },
    {
      "source": "pack:067-gf-aisi-nus-unicode-utf-8",
      "target": "font:768",
      "relation": "contains"
    },
    {
      "source": "pack:067-gf-aisi-nus-unicode-utf-8",
      "target": "font:767",
      "relation": "contains"
    },
    {
      "source": "pack:067-gf-aisi-nus-unicode-utf-8",
      "target": "font:765",
      "relation": "contains"
    },
    {
      "source": "pack:068-gf-aisi-nus-light-unicode-utf-8",
      "target": "font:771",
      "relation": "contains"
    },
    {
      "source": "pack:068-gf-aisi-nus-light-unicode-utf-8",
      "target": "font:772",
      "relation": "contains"
    },
    {
      "source": "pack:069-gf-aisi-nus-medium-unicode-utf-8",
      "target": "font:769",
      "relation": "contains"
    },
    {
      "source": "pack:069-gf-aisi-nus-medium-unicode-utf-8",
      "target": "font:770",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:830",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:831",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:825",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:827",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:826",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:828",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:829",
      "relation": "contains"
    },
    {
      "source": "pack:070-gf-alaverdi-mt-unicode-utf-8",
      "target": "font:824",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:822",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:823",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:817",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:819",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:818",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:820",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:821",
      "relation": "contains"
    },
    {
      "source": "pack:071-gf-alaverdi-nus-unicode-utf-8",
      "target": "font:816",
      "relation": "contains"
    },
    {
      "source": "pack:072-gf-satellite-17-mt-latin",
      "target": "font:432",
      "relation": "contains"
    },
    {
      "source": "pack:072-gf-satellite-17-mt-latin",
      "target": "font:433",
      "relation": "contains"
    },
    {
      "source": "pack:073-gf-satellite-2-mt-latin",
      "target": "font:423",
      "relation": "contains"
    },
    {
      "source": "pack:073-gf-satellite-2-mt-latin",
      "target": "font:424",
      "relation": "contains"
    },
    {
      "source": "pack:073-gf-satellite-2-mt-latin",
      "target": "font:426",
      "relation": "contains"
    },
    {
      "source": "pack:073-gf-satellite-2-mt-latin",
      "target": "font:425",
      "relation": "contains"
    },
    {
      "source": "pack:074-gf-satellite-28-mt-latin",
      "target": "font:434",
      "relation": "contains"
    },
    {
      "source": "pack:074-gf-satellite-28-mt-latin",
      "target": "font:435",
      "relation": "contains"
    },
    {
      "source": "pack:075-gf-satellite-3-mt-latin",
      "target": "font:427",
      "relation": "contains"
    },
    {
      "source": "pack:075-gf-satellite-3-mt-latin",
      "target": "font:428",
      "relation": "contains"
    },
    {
      "source": "pack:076-gf-satellite-6-mt-latin",
      "target": "font:429",
      "relation": "contains"
    },
    {
      "source": "pack:076-gf-satellite-6-mt-latin",
      "target": "font:430",
      "relation": "contains"
    },
    {
      "source": "pack:076-gf-satellite-6-mt-latin",
      "target": "font:431",
      "relation": "contains"
    },
    {
      "source": "pack:077-gl-lortkipanidze-unicode-utf-8",
      "target": "font:861",
      "relation": "contains"
    },
    {
      "source": "pack:077-gl-lortkipanidze-unicode-utf-8",
      "target": "font:860",
      "relation": "contains"
    },
    {
      "source": "pack:078-gogebashvili-itv-latin",
      "target": "font:38",
      "relation": "contains"
    },
    {
      "source": "pack:078-gogebashvili-itv-latin",
      "target": "font:39",
      "relation": "contains"
    },
    {
      "source": "pack:078-gogebashvili-itv-latin",
      "target": "font:41",
      "relation": "contains"
    },
    {
      "source": "pack:078-gogebashvili-itv-latin",
      "target": "font:40",
      "relation": "contains"
    },
    {
      "source": "pack:079-grigoliapolygraph-latin",
      "target": "font:449",
      "relation": "contains"
    },
    {
      "source": "pack:079-grigoliapolygraph-latin",
      "target": "font:450",
      "relation": "contains"
    },
    {
      "source": "pack:080-hkolkhetymtav-latin",
      "target": "font:464",
      "relation": "contains"
    },
    {
      "source": "pack:080-hkolkhetymtav-latin",
      "target": "font:465",
      "relation": "contains"
    },
    {
      "source": "pack:081-kolkhety-latin",
      "target": "font:473",
      "relation": "contains"
    },
    {
      "source": "pack:081-kolkhety-latin",
      "target": "font:474",
      "relation": "contains"
    },
    {
      "source": "pack:082-kolkhety-itv-latin",
      "target": "font:42",
      "relation": "contains"
    },
    {
      "source": "pack:082-kolkhety-itv-latin",
      "target": "font:43",
      "relation": "contains"
    },
    {
      "source": "pack:082-kolkhety-itv-latin",
      "target": "font:45",
      "relation": "contains"
    },
    {
      "source": "pack:082-kolkhety-itv-latin",
      "target": "font:44",
      "relation": "contains"
    },
    {
      "source": "pack:083-literaturuli-td-latin",
      "target": "font:478",
      "relation": "contains"
    },
    {
      "source": "pack:083-literaturuli-td-latin",
      "target": "font:479",
      "relation": "contains"
    },
    {
      "source": "pack:083-literaturuli-td-latin",
      "target": "font:481",
      "relation": "contains"
    },
    {
      "source": "pack:083-literaturuli-td-latin",
      "target": "font:480",
      "relation": "contains"
    },
    {
      "source": "pack:084-literaturuly-itv-latin",
      "target": "font:46",
      "relation": "contains"
    },
    {
      "source": "pack:084-literaturuly-itv-latin",
      "target": "font:47",
      "relation": "contains"
    },
    {
      "source": "pack:084-literaturuly-itv-latin",
      "target": "font:49",
      "relation": "contains"
    },
    {
      "source": "pack:084-literaturuly-itv-latin",
      "target": "font:48",
      "relation": "contains"
    },
    {
      "source": "pack:085-litermtavr-latin",
      "target": "font:659",
      "relation": "contains"
    },
    {
      "source": "pack:085-litermtavr-latin",
      "target": "font:660",
      "relation": "contains"
    },
    {
      "source": "pack:086-liternusx-latin",
      "target": "font:658",
      "relation": "contains"
    },
    {
      "source": "pack:086-liternusx-latin",
      "target": "font:657",
      "relation": "contains"
    },
    {
      "source": "pack:087-metroff-latin",
      "target": "font:496",
      "relation": "contains"
    },
    {
      "source": "pack:087-metroff-latin",
      "target": "font:628",
      "relation": "contains"
    },
    {
      "source": "pack:088-sokolxety-latin",
      "target": "font:520",
      "relation": "contains"
    },
    {
      "source": "pack:088-sokolxety-latin",
      "target": "font:521",
      "relation": "contains"
    },
    {
      "source": "pack:089-spacademi-std8-geo-sp",
      "target": "font:522",
      "relation": "contains"
    },
    {
      "source": "pack:089-spacademi-std8-geo-sp",
      "target": "font:523",
      "relation": "contains"
    },
    {
      "source": "pack:090-spacademi-mt-std8-geo-sp",
      "target": "font:525",
      "relation": "contains"
    },
    {
      "source": "pack:090-spacademi-mt-std8-geo-sp",
      "target": "font:524",
      "relation": "contains"
    },
    {
      "source": "pack:091-spchveulebrivi-std8-geo-sp",
      "target": "font:528",
      "relation": "contains"
    },
    {
      "source": "pack:091-spchveulebrivi-std8-geo-sp",
      "target": "font:527",
      "relation": "contains"
    },
    {
      "source": "pack:092-spchveulebrivimt-std8-geo-sp",
      "target": "font:530",
      "relation": "contains"
    },
    {
      "source": "pack:092-spchveulebrivimt-std8-geo-sp",
      "target": "font:529",
      "relation": "contains"
    },
    {
      "source": "pack:093-spgrigolia-std8-geo-sp",
      "target": "font:537",
      "relation": "contains"
    },
    {
      "source": "pack:093-spgrigolia-std8-geo-sp",
      "target": "font:538",
      "relation": "contains"
    },
    {
      "source": "pack:094-spgrigolia-mt-std8-geo-sp",
      "target": "font:539",
      "relation": "contains"
    },
    {
      "source": "pack:094-spgrigolia-mt-std8-geo-sp",
      "target": "font:540",
      "relation": "contains"
    },
    {
      "source": "pack:095-spkolheti-std8-geo-sp",
      "target": "font:543",
      "relation": "contains"
    },
    {
      "source": "pack:095-spkolheti-std8-geo-sp",
      "target": "font:542",
      "relation": "contains"
    },
    {
      "source": "pack:096-spkolhetimt-std8-geo-sp",
      "target": "font:545",
      "relation": "contains"
    },
    {
      "source": "pack:096-spkolhetimt-std8-geo-sp",
      "target": "font:544",
      "relation": "contains"
    },
    {
      "source": "pack:097-spliteraturuly-std8-geo-sp",
      "target": "font:546",
      "relation": "contains"
    },
    {
      "source": "pack:097-spliteraturuly-std8-geo-sp",
      "target": "font:547",
      "relation": "contains"
    },
    {
      "source": "pack:098-spparliament-std8-geo-sp",
      "target": "font:552",
      "relation": "contains"
    },
    {
      "source": "pack:098-spparliament-std8-geo-sp",
      "target": "font:551",
      "relation": "contains"
    },
    {
      "source": "pack:099-spparliamentmt-std8-geo-sp",
      "target": "font:554",
      "relation": "contains"
    },
    {
      "source": "pack:099-spparliamentmt-std8-geo-sp",
      "target": "font:553",
      "relation": "contains"
    },
    {
      "source": "pack:100-spsiradze-std8-geo-sp",
      "target": "font:558",
      "relation": "contains"
    },
    {
      "source": "pack:100-spsiradze-std8-geo-sp",
      "target": "font:559",
      "relation": "contains"
    },
    {
      "source": "pack:101-spvena-std8-geo-sp",
      "target": "font:561",
      "relation": "contains"
    },
    {
      "source": "pack:101-spvena-std8-geo-sp",
      "target": "font:560",
      "relation": "contains"
    },
    {
      "source": "pack:102-titus-mxedruli-latin",
      "target": "font:615",
      "relation": "contains"
    },
    {
      "source": "pack:102-titus-mxedruli-latin",
      "target": "font:614",
      "relation": "contains"
    },
    {
      "source": "pack:103-kolhetymt-latin",
      "target": "font:736",
      "relation": "contains"
    },
    {
      "source": "pack:103-kolhetymt-latin",
      "target": "font:735",
      "relation": "contains"
    }
  ],
  "reviewGroups": [
    {
      "family": "Academiury-ITV",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "17",
        "22",
        "18",
        "23",
        "21",
        "25",
        "19",
        "24"
      ]
    },
    {
      "family": "BPG Algeti",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "99",
        "100"
      ]
    },
    {
      "family": "BPG Algeti Compact",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "101",
        "102"
      ]
    },
    {
      "family": "BPG Glaho 2008",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "109",
        "110"
      ]
    },
    {
      "family": "BPG Glaho Arial 2008",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "112",
        "113"
      ]
    },
    {
      "family": "BPG Irubaqidze",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "123",
        "124"
      ]
    },
    {
      "family": "BPG Nino Mkhedruli",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "146",
        "152"
      ]
    },
    {
      "family": "BPG Nino Mkhedruli Bold",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "147",
        "153"
      ]
    },
    {
      "family": "BPG Nino Mkhedruli Book",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "148",
        "154"
      ]
    },
    {
      "family": "BPG Nino Mtavruli",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "143",
        "149"
      ]
    },
    {
      "family": "BPG Nino Mtavruli Bold",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "145",
        "151"
      ]
    },
    {
      "family": "BPG Nino Mtavruli Book",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "144",
        "150"
      ]
    },
    {
      "family": "BPG Nostalgia",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "156",
        "158",
        "157",
        "159"
      ]
    },
    {
      "family": "BPG ParaGraph Chveulebrivi",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "168",
        "169"
      ]
    },
    {
      "family": "BPG Ucnobi",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "182",
        "183"
      ]
    },
    {
      "family": "DejaVu Sans (BPG DejaVu Sans)",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "127",
        "128"
      ]
    },
    {
      "family": "Mzeqala",
      "reason": "Same named styles contain different files; needs version review.",
      "ids": [
        "832",
        "833"
      ]
    }
  ],
  "notes": [
    "Exact file duplicates were removed within each proposed pack using SHA-256.",
    "Families with different files sharing a font name are held for review.",
    "Family grouping uses catalog metadata, not visual or neural-network inference.",
    "License metadata remains attached to each font; a pack does not change licensing.",
    "Font IDs are stable catalog references; link targets use font:<id>."
  ]
}